export const dbProducts = {
  "products": [
    {
      "id": "prod_1",
      "name": "Zicom Wi-Fi PTZ Camera - Professional Series 1",
      "category": "Security Systems",
      "brand": "Zicom",
      "image": "https://cdn.moglix.com/p/UebVLIN9113Kg-xxlarge.jpg",
      "rating": "4.0",
      "reviewsCount": 334,
      "price": "₹1,823",
      "oldPrice": "₹2,941",
      "discount": "38% OFF",
      "inStock": true,
      "stockQuantity": 102,
      "isDeal": false,
      "description": "High quality Zicom Wi-Fi PTZ Camera - Professional Series 1 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_2",
      "name": "Dahua Biometric Attendance System - Professional Series 2",
      "category": "Security Systems",
      "brand": "Dahua",
      "image": "https://cdn.moglix.com/p/JTOpd1KpH7kKt-xxlarge.png",
      "rating": "4.4",
      "reviewsCount": 139,
      "price": "₹481",
      "oldPrice": "₹566",
      "discount": "15% OFF",
      "inStock": true,
      "stockQuantity": 23,
      "isDeal": false,
      "description": "High quality Dahua Biometric Attendance System - Professional Series 2 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_3",
      "name": "Godrej DVR 8-Channel - Professional Series 3",
      "category": "Security Systems",
      "brand": "Godrej",
      "image": "https://cdn.moglix.com/p/mVcnIu69b94pA-xxlarge.jpg",
      "rating": "4.0",
      "reviewsCount": 93,
      "price": "₹1,032",
      "oldPrice": "₹2,025",
      "discount": "49% OFF",
      "inStock": true,
      "stockQuantity": 32,
      "isDeal": false,
      "description": "High quality Godrej DVR 8-Channel - Professional Series 3 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_4",
      "name": "Hikvision Smart Door Lock - Professional Series 4",
      "category": "Security Systems",
      "brand": "Hikvision",
      "image": "https://cdn.moglix.com/p/ZROQhxfDpItzs-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 42,
      "price": "₹3,505",
      "oldPrice": "₹4,612",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 65,
      "isDeal": true,
      "description": "High quality Hikvision Smart Door Lock - Professional Series 4 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_5",
      "name": "CP PLUS Motion Sensor - Professional Series 5",
      "category": "Security Systems",
      "brand": "CP PLUS",
      "image": "https://cdn.moglix.com/p/WXHBytqNtGe5B-xxlarge.jpg",
      "rating": "4.7",
      "reviewsCount": 219,
      "price": "₹1,587",
      "oldPrice": "₹2,995",
      "discount": "47% OFF",
      "inStock": true,
      "stockQuantity": 78,
      "isDeal": false,
      "description": "High quality CP PLUS Motion Sensor - Professional Series 5 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_6",
      "name": "Hikvision Smart Door Lock - Professional Series 6",
      "category": "Security Systems",
      "brand": "Hikvision",
      "image": "https://cdn.moglix.com/p/GFK05uvAFEFly-xxlarge.png",
      "rating": "5.0",
      "reviewsCount": 219,
      "price": "₹1,013",
      "oldPrice": "₹1,748",
      "discount": "42% OFF",
      "inStock": true,
      "stockQuantity": 95,
      "isDeal": false,
      "description": "High quality Hikvision Smart Door Lock - Professional Series 6 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_7",
      "name": "Godrej Biometric Attendance System - Professional Series 7",
      "category": "Security Systems",
      "brand": "Godrej",
      "image": "https://cdn.moglix.com/p/CK896mMQhMBp9-xxlarge.png",
      "rating": "4.4",
      "reviewsCount": 398,
      "price": "₹2,724",
      "oldPrice": "₹4,066",
      "discount": "33% OFF",
      "inStock": true,
      "stockQuantity": 35,
      "isDeal": false,
      "description": "High quality Godrej Biometric Attendance System - Professional Series 7 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_8",
      "name": "CP PLUS Smart Door Lock - Professional Series 8",
      "category": "Security Systems",
      "brand": "CP PLUS",
      "image": "https://cdn.moglix.com/p/Hma8qSmh5SyqJ-xxlarge.jpg",
      "rating": "4.7",
      "reviewsCount": 474,
      "price": "₹794",
      "oldPrice": "₹1,418",
      "discount": "44% OFF",
      "inStock": true,
      "stockQuantity": 33,
      "isDeal": false,
      "description": "High quality CP PLUS Smart Door Lock - Professional Series 8 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_9",
      "name": "Hikvision Smoke Detector - Professional Series 9",
      "category": "Security Systems",
      "brand": "Hikvision",
      "image": "https://cdn.moglix.com/p/0tYl0Q32mBWCx-xxlarge.jpg",
      "rating": "4.9",
      "reviewsCount": 322,
      "price": "₹1,781",
      "oldPrice": "₹2,284",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 88,
      "isDeal": false,
      "description": "High quality Hikvision Smoke Detector - Professional Series 9 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_10",
      "name": "Godrej Smart Door Lock - Professional Series 10",
      "category": "Security Systems",
      "brand": "Godrej",
      "image": "https://cdn.moglix.com/p/XKrqpkAZlmRJv-xxlarge.png",
      "rating": "4.7",
      "reviewsCount": 383,
      "price": "₹645",
      "oldPrice": "₹1,196",
      "discount": "46% OFF",
      "inStock": true,
      "stockQuantity": 15,
      "isDeal": false,
      "description": "High quality Godrej Smart Door Lock - Professional Series 10 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_11",
      "name": "Dahua Smart Door Lock - Professional Series 11",
      "category": "Security Systems",
      "brand": "Dahua",
      "image": "https://cdn.moglix.com/p/pMSUPHYqh9f7U-xxlarge.jpg",
      "rating": "3.5",
      "reviewsCount": 16,
      "price": "₹1,447",
      "oldPrice": "₹2,262",
      "discount": "36% OFF",
      "inStock": true,
      "stockQuantity": 60,
      "isDeal": false,
      "description": "High quality Dahua Smart Door Lock - Professional Series 11 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_12",
      "name": "Zicom Smart Door Lock - Professional Series 12",
      "category": "Security Systems",
      "brand": "Zicom",
      "image": "https://cdn.moglix.com/p/YKGsFnKDSFsd2-xxlarge.jpg",
      "rating": "3.5",
      "reviewsCount": 112,
      "price": "₹2,452",
      "oldPrice": "₹2,787",
      "discount": "12% OFF",
      "inStock": true,
      "stockQuantity": 93,
      "isDeal": false,
      "description": "High quality Zicom Smart Door Lock - Professional Series 12 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_13",
      "name": "Dahua Biometric Attendance System - Professional Series 13",
      "category": "Security Systems",
      "brand": "Dahua",
      "image": "https://cdn.moglix.com/p/DUQPlB7t1sFSx-xxlarge.jpg",
      "rating": "4.6",
      "reviewsCount": 109,
      "price": "₹944",
      "oldPrice": "₹1,138",
      "discount": "17% OFF",
      "inStock": true,
      "stockQuantity": 70,
      "isDeal": false,
      "description": "High quality Dahua Biometric Attendance System - Professional Series 13 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_14",
      "name": "CP PLUS Smart Door Lock - Professional Series 14",
      "category": "Security Systems",
      "brand": "CP PLUS",
      "image": "https://cdn.moglix.com/p/i3DqCw63tFYqK-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 87,
      "price": "₹582",
      "oldPrice": "₹970",
      "discount": "40% OFF",
      "inStock": true,
      "stockQuantity": 46,
      "isDeal": true,
      "description": "High quality CP PLUS Smart Door Lock - Professional Series 14 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_15",
      "name": "Hikvision 4MP Dome Camera - Professional Series 15",
      "category": "Security Systems",
      "brand": "Hikvision",
      "image": "https://cdn.moglix.com/p/d2sBiTe7gpheY-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 110,
      "price": "₹2,208",
      "oldPrice": "₹3,620",
      "discount": "39% OFF",
      "inStock": true,
      "stockQuantity": 32,
      "isDeal": false,
      "description": "High quality Hikvision 4MP Dome Camera - Professional Series 15 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_16",
      "name": "D-Link Access Point - Professional Series 1",
      "category": "IT & Networking",
      "brand": "D-Link",
      "image": "https://cdn.moglix.com/p/mZ189pwELyRl1-xxlarge.jpg",
      "rating": "3.9",
      "reviewsCount": 336,
      "price": "₹2,645",
      "oldPrice": "₹3,266",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 34,
      "isDeal": false,
      "description": "High quality D-Link Access Point - Professional Series 1 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_17",
      "name": "Ubiquiti Mesh Wi-Fi System - Professional Series 2",
      "category": "IT & Networking",
      "brand": "Ubiquiti",
      "image": "https://cdn.moglix.com/p/D5UeC3raiqc8c-xxlarge.jpg",
      "rating": "4.0",
      "reviewsCount": 349,
      "price": "₹3,426",
      "oldPrice": "₹3,939",
      "discount": "13% OFF",
      "inStock": true,
      "stockQuantity": 91,
      "isDeal": false,
      "description": "High quality Ubiquiti Mesh Wi-Fi System - Professional Series 2 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_18",
      "name": "Cisco Mesh Wi-Fi System - Professional Series 3",
      "category": "IT & Networking",
      "brand": "Cisco",
      "image": "https://cdn.moglix.com/p/8cX5KnfhgBpfu-xxlarge.jpg",
      "rating": "4.6",
      "reviewsCount": 335,
      "price": "₹2,302",
      "oldPrice": "₹3,598",
      "discount": "36% OFF",
      "inStock": true,
      "stockQuantity": 63,
      "isDeal": false,
      "description": "High quality Cisco Mesh Wi-Fi System - Professional Series 3 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_19",
      "name": "Cisco Network Cabinet - Professional Series 4",
      "category": "IT & Networking",
      "brand": "Cisco",
      "image": "https://cdn.moglix.com/p/yDpGSG0rAz8oT-xxlarge.jpg",
      "rating": "4.8",
      "reviewsCount": 264,
      "price": "₹4,183",
      "oldPrice": "₹4,701",
      "discount": "11% OFF",
      "inStock": true,
      "stockQuantity": 20,
      "isDeal": false,
      "description": "High quality Cisco Network Cabinet - Professional Series 4 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_20",
      "name": "Ubiquiti 24-Port Switch - Professional Series 5",
      "category": "IT & Networking",
      "brand": "Ubiquiti",
      "image": "https://cdn.moglix.com/p/xaog42cJ0q0M0-xxlarge.jpg",
      "rating": "3.6",
      "reviewsCount": 484,
      "price": "₹1,372",
      "oldPrice": "₹1,695",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 10,
      "isDeal": true,
      "description": "High quality Ubiquiti 24-Port Switch - Professional Series 5 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_21",
      "name": "TP-Link Wi-Fi Extender - Professional Series 6",
      "category": "IT & Networking",
      "brand": "TP-Link",
      "image": "https://cdn.moglix.com/p/k0Ww6nb9S5S3f-xxlarge.jpg",
      "rating": "4.7",
      "reviewsCount": 443,
      "price": "₹3,700",
      "oldPrice": "₹4,253",
      "discount": "13% OFF",
      "inStock": true,
      "stockQuantity": 40,
      "isDeal": true,
      "description": "High quality TP-Link Wi-Fi Extender - Professional Series 6 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_22",
      "name": "Netgear Network Cabinet - Professional Series 7",
      "category": "IT & Networking",
      "brand": "Netgear",
      "image": "https://cdn.moglix.com/p/hxITT0DzP6Lbr-xxlarge.jpg",
      "rating": "3.8",
      "reviewsCount": 218,
      "price": "₹983",
      "oldPrice": "₹1,612",
      "discount": "39% OFF",
      "inStock": true,
      "stockQuantity": 37,
      "isDeal": false,
      "description": "High quality Netgear Network Cabinet - Professional Series 7 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_23",
      "name": "Cisco Cat6 Cable 305m - Professional Series 8",
      "category": "IT & Networking",
      "brand": "Cisco",
      "image": "https://cdn.moglix.com/p/QZWK5aYRhnnaj-xxlarge.jpg",
      "rating": "3.8",
      "reviewsCount": 211,
      "price": "₹3,561",
      "oldPrice": "₹5,162",
      "discount": "31% OFF",
      "inStock": true,
      "stockQuantity": 58,
      "isDeal": false,
      "description": "High quality Cisco Cat6 Cable 305m - Professional Series 8 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_24",
      "name": "D-Link 24-Port Switch - Professional Series 9",
      "category": "IT & Networking",
      "brand": "D-Link",
      "image": "https://cdn.moglix.com/p/95ULczD4qjxhc-xxlarge.jpg",
      "rating": "3.6",
      "reviewsCount": 203,
      "price": "₹3,310",
      "oldPrice": "₹4,190",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 65,
      "isDeal": false,
      "description": "High quality D-Link 24-Port Switch - Professional Series 9 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_25",
      "name": "D-Link Mesh Wi-Fi System - Professional Series 10",
      "category": "IT & Networking",
      "brand": "D-Link",
      "image": "https://cdn.moglix.com/p/sKQzRlxDUIapq-xxlarge.jpg",
      "rating": "4.1",
      "reviewsCount": 331,
      "price": "₹1,257",
      "oldPrice": "₹1,934",
      "discount": "35% OFF",
      "inStock": true,
      "stockQuantity": 31,
      "isDeal": true,
      "description": "High quality D-Link Mesh Wi-Fi System - Professional Series 10 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_26",
      "name": "TP-Link Access Point - Professional Series 11",
      "category": "IT & Networking",
      "brand": "TP-Link",
      "image": "https://cdn.moglix.com/p/cXFnIVvBJgLOW-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 226,
      "price": "₹4,522",
      "oldPrice": "₹5,449",
      "discount": "17% OFF",
      "inStock": true,
      "stockQuantity": 31,
      "isDeal": false,
      "description": "High quality TP-Link Access Point - Professional Series 11 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_27",
      "name": "Cisco Mesh Wi-Fi System - Professional Series 12",
      "category": "IT & Networking",
      "brand": "Cisco",
      "image": "https://cdn.moglix.com/p/nKaNxMF04QTAj-xxlarge.jpg",
      "rating": "4.2",
      "reviewsCount": 111,
      "price": "₹2,905",
      "oldPrice": "₹5,282",
      "discount": "45% OFF",
      "inStock": true,
      "stockQuantity": 19,
      "isDeal": false,
      "description": "High quality Cisco Mesh Wi-Fi System - Professional Series 12 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_28",
      "name": "TP-Link Network Cabinet - Professional Series 13",
      "category": "IT & Networking",
      "brand": "TP-Link",
      "image": "https://cdn.moglix.com/p/0MhM27l95nMtw-xxlarge.jpg",
      "rating": "4.0",
      "reviewsCount": 414,
      "price": "₹950",
      "oldPrice": "₹1,131",
      "discount": "16% OFF",
      "inStock": true,
      "stockQuantity": 23,
      "isDeal": false,
      "description": "High quality TP-Link Network Cabinet - Professional Series 13 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_29",
      "name": "Cisco 24-Port Switch - Professional Series 14",
      "category": "IT & Networking",
      "brand": "Cisco",
      "image": "https://cdn.moglix.com/p/fj2efYKTpaxnd-xxlarge.jpg",
      "rating": "4.0",
      "reviewsCount": 93,
      "price": "₹3,875",
      "oldPrice": "₹5,382",
      "discount": "28% OFF",
      "inStock": true,
      "stockQuantity": 27,
      "isDeal": false,
      "description": "High quality Cisco 24-Port Switch - Professional Series 14 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_30",
      "name": "Ubiquiti 24-Port Switch - Professional Series 15",
      "category": "IT & Networking",
      "brand": "Ubiquiti",
      "image": "https://cdn.moglix.com/p/QfK7L1SeE2Ekq-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 271,
      "price": "₹2,348",
      "oldPrice": "₹3,173",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 95,
      "isDeal": false,
      "description": "High quality Ubiquiti 24-Port Switch - Professional Series 15 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_31",
      "name": "Philips Flood Light 100W - Professional Series 1",
      "category": "Lighting Solutions",
      "brand": "Philips",
      "image": "https://cdn.moglix.com/p/57o24XTwI8s49-xxlarge.jpg",
      "rating": "3.9",
      "reviewsCount": 472,
      "price": "₹3,102",
      "oldPrice": "₹4,925",
      "discount": "37% OFF",
      "inStock": true,
      "stockQuantity": 85,
      "isDeal": false,
      "description": "High quality Philips Flood Light 100W - Professional Series 1 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_32",
      "name": "Crompton Strip Light 5m - Professional Series 2",
      "category": "Lighting Solutions",
      "brand": "Crompton",
      "image": "https://cdn.moglix.com/p/AXbhMKdpQql0w-xxlarge.png",
      "rating": "4.4",
      "reviewsCount": 289,
      "price": "₹432",
      "oldPrice": "₹746",
      "discount": "42% OFF",
      "inStock": true,
      "stockQuantity": 28,
      "isDeal": false,
      "description": "High quality Crompton Strip Light 5m - Professional Series 2 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_33",
      "name": "Syska 20W LED Tube - Professional Series 3",
      "category": "Lighting Solutions",
      "brand": "Syska",
      "image": "https://cdn.moglix.com/p/w5GuQfoUeMTvb-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 406,
      "price": "₹1,921",
      "oldPrice": "₹2,315",
      "discount": "17% OFF",
      "inStock": true,
      "stockQuantity": 94,
      "isDeal": false,
      "description": "High quality Syska 20W LED Tube - Professional Series 3 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_34",
      "name": "Wipro Panel Light - Professional Series 4",
      "category": "Lighting Solutions",
      "brand": "Wipro",
      "image": "https://cdn.moglix.com/p/r18lVLk0wOD96-xxlarge.jpg",
      "rating": "4.8",
      "reviewsCount": 75,
      "price": "₹3,463",
      "oldPrice": "₹5,411",
      "discount": "36% OFF",
      "inStock": true,
      "stockQuantity": 34,
      "isDeal": false,
      "description": "High quality Wipro Panel Light - Professional Series 4 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_35",
      "name": "Wipro Street Light 50W - Professional Series 5",
      "category": "Lighting Solutions",
      "brand": "Wipro",
      "image": "https://cdn.moglix.com/p/E5iykyKwSVBWJ-xxlarge.jpg",
      "rating": "3.6",
      "reviewsCount": 490,
      "price": "₹3,896",
      "oldPrice": "₹4,871",
      "discount": "20% OFF",
      "inStock": true,
      "stockQuantity": 47,
      "isDeal": true,
      "description": "High quality Wipro Street Light 50W - Professional Series 5 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_36",
      "name": "Havells 20W LED Tube - Professional Series 6",
      "category": "Lighting Solutions",
      "brand": "Havells",
      "image": "https://cdn.moglix.com/p/0GaxPwJDo9A9B-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 406,
      "price": "₹905",
      "oldPrice": "₹1,588",
      "discount": "43% OFF",
      "inStock": true,
      "stockQuantity": 16,
      "isDeal": false,
      "description": "High quality Havells 20W LED Tube - Professional Series 6 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_37",
      "name": "Syska 20W LED Tube - Professional Series 7",
      "category": "Lighting Solutions",
      "brand": "Syska",
      "image": "https://cdn.moglix.com/p/dLiLXsV6LLhpB-xxlarge.jpg",
      "rating": "3.7",
      "reviewsCount": 36,
      "price": "₹2,531",
      "oldPrice": "₹4,688",
      "discount": "46% OFF",
      "inStock": true,
      "stockQuantity": 62,
      "isDeal": false,
      "description": "High quality Syska 20W LED Tube - Professional Series 7 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_38",
      "name": "Wipro Panel Light - Professional Series 8",
      "category": "Lighting Solutions",
      "brand": "Wipro",
      "image": "https://cdn.moglix.com/p/mEGuQCOABSuFE-xxlarge.jpg",
      "rating": "4.8",
      "reviewsCount": 349,
      "price": "₹3,111",
      "oldPrice": "₹5,274",
      "discount": "41% OFF",
      "inStock": true,
      "stockQuantity": 108,
      "isDeal": false,
      "description": "High quality Wipro Panel Light - Professional Series 8 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_39",
      "name": "Crompton 9W LED Bulb (Pack of 4) - Professional Series 9",
      "category": "Lighting Solutions",
      "brand": "Crompton",
      "image": "https://cdn.moglix.com/p/qyBtexZwH0ww4-xxlarge.jpg",
      "rating": "3.8",
      "reviewsCount": 141,
      "price": "₹947",
      "oldPrice": "₹1,089",
      "discount": "13% OFF",
      "inStock": true,
      "stockQuantity": 22,
      "isDeal": false,
      "description": "High quality Crompton 9W LED Bulb (Pack of 4) - Professional Series 9 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_40",
      "name": "Wipro Flood Light 100W - Professional Series 10",
      "category": "Lighting Solutions",
      "brand": "Wipro",
      "image": "https://cdn.moglix.com/p/Oi2wrYENCtiXw-xxlarge.png",
      "rating": "3.6",
      "reviewsCount": 15,
      "price": "₹1,665",
      "oldPrice": "₹2,313",
      "discount": "28% OFF",
      "inStock": true,
      "stockQuantity": 101,
      "isDeal": false,
      "description": "High quality Wipro Flood Light 100W - Professional Series 10 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_41",
      "name": "Wipro 20W LED Tube - Professional Series 11",
      "category": "Lighting Solutions",
      "brand": "Wipro",
      "image": "https://cdn.moglix.com/p/J/H/5/d/MINJH5IPIR3R4-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 260,
      "price": "₹2,405",
      "oldPrice": "₹3,486",
      "discount": "31% OFF",
      "inStock": true,
      "stockQuantity": 17,
      "isDeal": false,
      "description": "High quality Wipro 20W LED Tube - Professional Series 11 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_42",
      "name": "Syska Flood Light 100W - Professional Series 12",
      "category": "Lighting Solutions",
      "brand": "Syska",
      "image": "https://cdn.moglix.com/p/GC10dMGGXSPOW-xxlarge.png",
      "rating": "3.7",
      "reviewsCount": 43,
      "price": "₹2,693",
      "oldPrice": "₹4,725",
      "discount": "43% OFF",
      "inStock": true,
      "stockQuantity": 87,
      "isDeal": false,
      "description": "High quality Syska Flood Light 100W - Professional Series 12 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_43",
      "name": "Crompton 20W LED Tube - Professional Series 13",
      "category": "Lighting Solutions",
      "brand": "Crompton",
      "image": "https://cdn.moglix.com/p/VQbsdrHaNRvUD-xxlarge.jpg",
      "rating": "3.7",
      "reviewsCount": 175,
      "price": "₹3,331",
      "oldPrice": "₹5,125",
      "discount": "35% OFF",
      "inStock": true,
      "stockQuantity": 43,
      "isDeal": true,
      "description": "High quality Crompton 20W LED Tube - Professional Series 13 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_44",
      "name": "Syska Flood Light 100W - Professional Series 14",
      "category": "Lighting Solutions",
      "brand": "Syska",
      "image": "https://cdn.moglix.com/p/oFvMnJZO05xiD-xxlarge.jpg",
      "rating": "4.1",
      "reviewsCount": 79,
      "price": "₹3,904",
      "oldPrice": "₹5,348",
      "discount": "27% OFF",
      "inStock": true,
      "stockQuantity": 97,
      "isDeal": false,
      "description": "High quality Syska Flood Light 100W - Professional Series 14 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_45",
      "name": "Wipro Street Light 50W - Professional Series 15",
      "category": "Lighting Solutions",
      "brand": "Wipro",
      "image": "https://cdn.moglix.com/p/czdrSfMZALcVS-xxlarge.jpg",
      "rating": "5.0",
      "reviewsCount": 214,
      "price": "₹1,748",
      "oldPrice": "₹3,123",
      "discount": "44% OFF",
      "inStock": true,
      "stockQuantity": 25,
      "isDeal": false,
      "description": "High quality Wipro Street Light 50W - Professional Series 15 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_46",
      "name": "Prestige Induction Cooktop - Professional Series 1",
      "category": "Electricals",
      "brand": "Prestige",
      "image": "https://cdn.moglix.com/p/eP5FE4R7tKCnF-xxlarge.jpg",
      "rating": "4.0",
      "reviewsCount": 399,
      "price": "₹662",
      "oldPrice": "₹1,204",
      "discount": "45% OFF",
      "inStock": true,
      "stockQuantity": 34,
      "isDeal": true,
      "description": "High quality Prestige Induction Cooktop - Professional Series 1 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_47",
      "name": "Bajaj Electric Kettle 1.5L - Professional Series 2",
      "category": "Electricals",
      "brand": "Bajaj",
      "image": "https://cdn.moglix.com/p/02vi9eTpwHBlD-xxlarge.jpg",
      "rating": "3.6",
      "reviewsCount": 395,
      "price": "₹1,193",
      "oldPrice": "₹1,404",
      "discount": "15% OFF",
      "inStock": true,
      "stockQuantity": 60,
      "isDeal": false,
      "description": "High quality Bajaj Electric Kettle 1.5L - Professional Series 2 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_48",
      "name": "Orient Ceiling Fan 1200mm - Professional Series 3",
      "category": "Electricals",
      "brand": "Orient",
      "image": "https://cdn.moglix.com/p/8FylQzBvknPCH-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 509,
      "price": "₹3,174",
      "oldPrice": "₹4,601",
      "discount": "31% OFF",
      "inStock": true,
      "stockQuantity": 57,
      "isDeal": false,
      "description": "High quality Orient Ceiling Fan 1200mm - Professional Series 3 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_49",
      "name": "Prestige Room Heater - Professional Series 4",
      "category": "Electricals",
      "brand": "Prestige",
      "image": "https://cdn.moglix.com/p/OWRqVbmC7dBkd-xxlarge.jpg",
      "rating": "3.7",
      "reviewsCount": 372,
      "price": "₹1,823",
      "oldPrice": "₹2,368",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 89,
      "isDeal": false,
      "description": "High quality Prestige Room Heater - Professional Series 4 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_50",
      "name": "Usha Room Heater - Professional Series 5",
      "category": "Electricals",
      "brand": "Usha",
      "image": "https://cdn.moglix.com/p/ajeB4erDeddJo-xxlarge.jpg",
      "rating": "3.7",
      "reviewsCount": 448,
      "price": "₹584",
      "oldPrice": "₹1,008",
      "discount": "42% OFF",
      "inStock": true,
      "stockQuantity": 37,
      "isDeal": false,
      "description": "High quality Usha Room Heater - Professional Series 5 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_51",
      "name": "Havells Electric Kettle 1.5L - Professional Series 6",
      "category": "Electricals",
      "brand": "Havells",
      "image": "https://cdn.moglix.com/p/dXxcgIyE9iuPy-xxlarge.jpeg",
      "rating": "3.8",
      "reviewsCount": 419,
      "price": "₹992",
      "oldPrice": "₹1,682",
      "discount": "41% OFF",
      "inStock": true,
      "stockQuantity": 39,
      "isDeal": false,
      "description": "High quality Havells Electric Kettle 1.5L - Professional Series 6 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_52",
      "name": "Prestige Electric Kettle 1.5L - Professional Series 7",
      "category": "Electricals",
      "brand": "Prestige",
      "image": "https://cdn.moglix.com/p/kS9nKbr5QP0AK-xxlarge.jpeg",
      "rating": "3.7",
      "reviewsCount": 56,
      "price": "₹484",
      "oldPrice": "₹950",
      "discount": "49% OFF",
      "inStock": true,
      "stockQuantity": 25,
      "isDeal": true,
      "description": "High quality Prestige Electric Kettle 1.5L - Professional Series 7 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_53",
      "name": "Usha Ceiling Fan 1200mm - Professional Series 8",
      "category": "Electricals",
      "brand": "Usha",
      "image": "https://cdn.moglix.com/p/a4XVNWM8VRtt6-xxlarge.jpg",
      "rating": "3.6",
      "reviewsCount": 503,
      "price": "₹3,744",
      "oldPrice": "₹4,863",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 28,
      "isDeal": false,
      "description": "High quality Usha Ceiling Fan 1200mm - Professional Series 8 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_54",
      "name": "Prestige Ceiling Fan 1200mm - Professional Series 9",
      "category": "Electricals",
      "brand": "Prestige",
      "image": "https://cdn.moglix.com/p/LgxECtQvpdGqv-xxlarge.jpg",
      "rating": "3.8",
      "reviewsCount": 271,
      "price": "₹3,454",
      "oldPrice": "₹4,112",
      "discount": "16% OFF",
      "inStock": true,
      "stockQuantity": 106,
      "isDeal": true,
      "description": "High quality Prestige Ceiling Fan 1200mm - Professional Series 9 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_55",
      "name": "Prestige Electric Kettle 1.5L - Professional Series 10",
      "category": "Electricals",
      "brand": "Prestige",
      "image": "https://cdn.moglix.com/p/xLpBGyKOAxqNx-xxlarge.jpg",
      "rating": "4.1",
      "reviewsCount": 431,
      "price": "₹1,123",
      "oldPrice": "₹1,322",
      "discount": "15% OFF",
      "inStock": true,
      "stockQuantity": 31,
      "isDeal": false,
      "description": "High quality Prestige Electric Kettle 1.5L - Professional Series 10 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_56",
      "name": "Prestige Room Heater - Professional Series 11",
      "category": "Electricals",
      "brand": "Prestige",
      "image": "https://cdn.moglix.com/p/4S9ehYHJeejt3-xxlarge.jpg",
      "rating": "3.5",
      "reviewsCount": 421,
      "price": "₹1,672",
      "oldPrice": "₹2,459",
      "discount": "32% OFF",
      "inStock": true,
      "stockQuantity": 23,
      "isDeal": false,
      "description": "High quality Prestige Room Heater - Professional Series 11 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_57",
      "name": "Bajaj Induction Cooktop - Professional Series 12",
      "category": "Electricals",
      "brand": "Bajaj",
      "image": "https://cdn.moglix.com/p/wwVuThOOnHOy2-xxlarge.jpeg",
      "rating": "4.3",
      "reviewsCount": 486,
      "price": "₹4,250",
      "oldPrice": "₹5,380",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 71,
      "isDeal": false,
      "description": "High quality Bajaj Induction Cooktop - Professional Series 12 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_58",
      "name": "Orient Ceiling Fan 1200mm - Professional Series 13",
      "category": "Electricals",
      "brand": "Orient",
      "image": "https://cdn.moglix.com/p/eJQDBz6HgNrBt-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 287,
      "price": "₹2,015",
      "oldPrice": "₹2,519",
      "discount": "20% OFF",
      "inStock": true,
      "stockQuantity": 92,
      "isDeal": false,
      "description": "High quality Orient Ceiling Fan 1200mm - Professional Series 13 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_59",
      "name": "Usha Induction Cooktop - Professional Series 14",
      "category": "Electricals",
      "brand": "Usha",
      "image": "https://cdn.moglix.com/p/9eQNlju4WmL9T-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 178,
      "price": "₹2,834",
      "oldPrice": "₹4,169",
      "discount": "32% OFF",
      "inStock": true,
      "stockQuantity": 35,
      "isDeal": true,
      "description": "High quality Usha Induction Cooktop - Professional Series 14 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_60",
      "name": "Prestige Induction Cooktop - Professional Series 15",
      "category": "Electricals",
      "brand": "Prestige",
      "image": "https://cdn.moglix.com/p/bF98ybEea1Q80-xxlarge.jpg",
      "rating": "4.8",
      "reviewsCount": 13,
      "price": "₹2,785",
      "oldPrice": "₹5,064",
      "discount": "45% OFF",
      "inStock": true,
      "stockQuantity": 23,
      "isDeal": false,
      "description": "High quality Prestige Induction Cooktop - Professional Series 15 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_61",
      "name": "Hitachi Circular Saw - Professional Series 1",
      "category": "Hardware",
      "brand": "Hitachi",
      "image": "https://cdn.moglix.com/p/5JzjecrP8bwsk-xxlarge.jpg",
      "rating": "4.1",
      "reviewsCount": 236,
      "price": "₹1,020",
      "oldPrice": "₹1,673",
      "discount": "39% OFF",
      "inStock": true,
      "stockQuantity": 42,
      "isDeal": false,
      "description": "High quality Hitachi Circular Saw - Professional Series 1 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_62",
      "name": "Black & Decker Impact Drill 13mm - Professional Series 2",
      "category": "Hardware",
      "brand": "Black & Decker",
      "image": "https://cdn.moglix.com/p/afLjsYaqNE4at-xxlarge.jpg",
      "rating": "5.0",
      "reviewsCount": 83,
      "price": "₹1,857",
      "oldPrice": "₹3,149",
      "discount": "41% OFF",
      "inStock": true,
      "stockQuantity": 23,
      "isDeal": false,
      "description": "High quality Black & Decker Impact Drill 13mm - Professional Series 2 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_63",
      "name": "Makita Circular Saw - Professional Series 3",
      "category": "Hardware",
      "brand": "Makita",
      "image": "https://cdn.moglix.com/p/ILO979GuJQ5DG-xxlarge.jpg",
      "rating": "3.5",
      "reviewsCount": 447,
      "price": "₹2,373",
      "oldPrice": "₹2,826",
      "discount": "16% OFF",
      "inStock": true,
      "stockQuantity": 71,
      "isDeal": false,
      "description": "High quality Makita Circular Saw - Professional Series 3 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_64",
      "name": "DeWalt Cordless Drill 12V - Professional Series 4",
      "category": "Hardware",
      "brand": "DeWalt",
      "image": "https://cdn.moglix.com/p/pmWWIrDmTN1Y6-xxlarge.jpg",
      "rating": "4.9",
      "reviewsCount": 303,
      "price": "₹1,220",
      "oldPrice": "₹2,141",
      "discount": "43% OFF",
      "inStock": true,
      "stockQuantity": 97,
      "isDeal": false,
      "description": "High quality DeWalt Cordless Drill 12V - Professional Series 4 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_65",
      "name": "Hitachi Rotary Hammer - Professional Series 5",
      "category": "Hardware",
      "brand": "Hitachi",
      "image": "https://cdn.moglix.com/p/s3RGc05M9lIWk-xxlarge.jpg",
      "rating": "3.6",
      "reviewsCount": 163,
      "price": "₹3,823",
      "oldPrice": "₹4,552",
      "discount": "16% OFF",
      "inStock": true,
      "stockQuantity": 37,
      "isDeal": false,
      "description": "High quality Hitachi Rotary Hammer - Professional Series 5 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_66",
      "name": "DeWalt Angle Grinder 4-Inch - Professional Series 6",
      "category": "Hardware",
      "brand": "DeWalt",
      "image": "https://cdn.moglix.com/p/D3wLDNsEzwI37-xxlarge.jpg",
      "rating": "4.0",
      "reviewsCount": 300,
      "price": "₹953",
      "oldPrice": "₹1,734",
      "discount": "45% OFF",
      "inStock": true,
      "stockQuantity": 20,
      "isDeal": false,
      "description": "High quality DeWalt Angle Grinder 4-Inch - Professional Series 6 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_67",
      "name": "Makita Cordless Drill 12V - Professional Series 7",
      "category": "Hardware",
      "brand": "Makita",
      "image": "https://cdn.moglix.com/p/R3JESJapPAhd7-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 309,
      "price": "₹1,686",
      "oldPrice": "₹2,635",
      "discount": "36% OFF",
      "inStock": true,
      "stockQuantity": 104,
      "isDeal": false,
      "description": "High quality Makita Cordless Drill 12V - Professional Series 7 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_68",
      "name": "Bosch Jigsaw 400W - Professional Series 8",
      "category": "Hardware",
      "brand": "Bosch",
      "image": "https://cdn.moglix.com/p/6BAPrL7BOEYlp-xxlarge.jpg",
      "rating": "4.1",
      "reviewsCount": 499,
      "price": "₹3,651",
      "oldPrice": "₹4,149",
      "discount": "12% OFF",
      "inStock": true,
      "stockQuantity": 73,
      "isDeal": true,
      "description": "High quality Bosch Jigsaw 400W - Professional Series 8 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_69",
      "name": "Black & Decker Impact Drill 13mm - Professional Series 9",
      "category": "Hardware",
      "brand": "Black & Decker",
      "image": "https://cdn.moglix.com/p/5p6w3EmBQi0Wz-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 500,
      "price": "₹3,034",
      "oldPrice": "₹3,793",
      "discount": "20% OFF",
      "inStock": true,
      "stockQuantity": 29,
      "isDeal": true,
      "description": "High quality Black & Decker Impact Drill 13mm - Professional Series 9 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_70",
      "name": "Hitachi Rotary Hammer - Professional Series 10",
      "category": "Hardware",
      "brand": "Hitachi",
      "image": "https://cdn.moglix.com/p/DuaHkckvN3c8h-xxlarge.jpg",
      "rating": "4.8",
      "reviewsCount": 453,
      "price": "₹1,979",
      "oldPrice": "₹2,749",
      "discount": "28% OFF",
      "inStock": true,
      "stockQuantity": 90,
      "isDeal": false,
      "description": "High quality Hitachi Rotary Hammer - Professional Series 10 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_71",
      "name": "Makita Impact Drill 13mm - Professional Series 11",
      "category": "Hardware",
      "brand": "Makita",
      "image": "https://cdn.moglix.com/p/rsjNyah0LTotI-xxlarge.jpg",
      "rating": "4.6",
      "reviewsCount": 358,
      "price": "₹3,770",
      "oldPrice": "₹5,027",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 48,
      "isDeal": true,
      "description": "High quality Makita Impact Drill 13mm - Professional Series 11 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_72",
      "name": "Bosch Heat Gun - Professional Series 12",
      "category": "Hardware",
      "brand": "Bosch",
      "image": "https://cdn.moglix.com/p/FTS4LA573blIC-xxlarge.jpg",
      "rating": "4.9",
      "reviewsCount": 150,
      "price": "₹2,100",
      "oldPrice": "₹2,414",
      "discount": "13% OFF",
      "inStock": true,
      "stockQuantity": 54,
      "isDeal": true,
      "description": "High quality Bosch Heat Gun - Professional Series 12 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_73",
      "name": "Black & Decker Cordless Drill 12V - Professional Series 13",
      "category": "Hardware",
      "brand": "Black & Decker",
      "image": "https://cdn.moglix.com/p/E5b4LRHhE94nb-xxlarge.jpg",
      "rating": "4.1",
      "reviewsCount": 266,
      "price": "₹2,172",
      "oldPrice": "₹4,259",
      "discount": "49% OFF",
      "inStock": true,
      "stockQuantity": 12,
      "isDeal": false,
      "description": "High quality Black & Decker Cordless Drill 12V - Professional Series 13 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_74",
      "name": "Black & Decker Jigsaw 400W - Professional Series 14",
      "category": "Hardware",
      "brand": "Black & Decker",
      "image": "https://cdn.moglix.com/p/AHzCsQrlJYv4x-xxlarge.jpg",
      "rating": "4.2",
      "reviewsCount": 323,
      "price": "₹1,833",
      "oldPrice": "₹3,107",
      "discount": "41% OFF",
      "inStock": true,
      "stockQuantity": 28,
      "isDeal": true,
      "description": "High quality Black & Decker Jigsaw 400W - Professional Series 14 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_75",
      "name": "Black & Decker Cordless Drill 12V - Professional Series 15",
      "category": "Hardware",
      "brand": "Black & Decker",
      "image": "https://cdn.moglix.com/p/2LbEeFlGuIDPb-xxlarge.jpg",
      "rating": "4.2",
      "reviewsCount": 183,
      "price": "₹1,570",
      "oldPrice": "₹3,079",
      "discount": "49% OFF",
      "inStock": true,
      "stockQuantity": 60,
      "isDeal": false,
      "description": "High quality Black & Decker Cordless Drill 12V - Professional Series 15 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_76",
      "name": "Allen Cooper Cut Resistant Gloves - Professional Series 1",
      "category": "Safety Products",
      "brand": "Allen Cooper",
      "image": "https://cdn.moglix.com/p/I/P/J/d/MINIPJECIU70W-xxlarge.jpg",
      "rating": "4.2",
      "reviewsCount": 406,
      "price": "₹2,922",
      "oldPrice": "₹3,284",
      "discount": "11% OFF",
      "inStock": true,
      "stockQuantity": 103,
      "isDeal": false,
      "description": "High quality Allen Cooper Cut Resistant Gloves - Professional Series 1 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_77",
      "name": "Liberty Safety Helmet - Professional Series 2",
      "category": "Safety Products",
      "brand": "Liberty",
      "image": "https://cdn.moglix.com/p/w9mCK12856tG4-xxlarge.jpg",
      "rating": "3.6",
      "reviewsCount": 29,
      "price": "₹1,806",
      "oldPrice": "₹2,150",
      "discount": "16% OFF",
      "inStock": true,
      "stockQuantity": 32,
      "isDeal": false,
      "description": "High quality Liberty Safety Helmet - Professional Series 2 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_78",
      "name": "Karam Reflective Jacket - Professional Series 3",
      "category": "Safety Products",
      "brand": "Karam",
      "image": "https://cdn.moglix.com/p/Gll1nozoHbLtC-xxlarge.jpg",
      "rating": "3.9",
      "reviewsCount": 138,
      "price": "₹1,423",
      "oldPrice": "₹2,259",
      "discount": "37% OFF",
      "inStock": true,
      "stockQuantity": 21,
      "isDeal": false,
      "description": "High quality Karam Reflective Jacket - Professional Series 3 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_79",
      "name": "Udyogi Reflective Jacket - Professional Series 4",
      "category": "Safety Products",
      "brand": "Udyogi",
      "image": "https://cdn.moglix.com/p/YjzNJaIkz2erp-xxlarge.jpg",
      "rating": "4.6",
      "reviewsCount": 325,
      "price": "₹1,260",
      "oldPrice": "₹1,637",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 84,
      "isDeal": false,
      "description": "High quality Udyogi Reflective Jacket - Professional Series 4 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_80",
      "name": "Udyogi Safety Goggles - Professional Series 5",
      "category": "Safety Products",
      "brand": "Udyogi",
      "image": "https://cdn.moglix.com/p/af5basRLA44A6-xxlarge.jpg",
      "rating": "4.8",
      "reviewsCount": 18,
      "price": "₹1,011",
      "oldPrice": "₹1,946",
      "discount": "48% OFF",
      "inStock": true,
      "stockQuantity": 58,
      "isDeal": false,
      "description": "High quality Udyogi Safety Goggles - Professional Series 5 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_81",
      "name": "Udyogi Safety Helmet - Professional Series 6",
      "category": "Safety Products",
      "brand": "Udyogi",
      "image": "https://cdn.moglix.com/p/6vXcCEuWD7AYF-xxlarge.jpg",
      "rating": "3.9",
      "reviewsCount": 453,
      "price": "₹2,025",
      "oldPrice": "₹2,894",
      "discount": "30% OFF",
      "inStock": true,
      "stockQuantity": 95,
      "isDeal": false,
      "description": "High quality Udyogi Safety Helmet - Professional Series 6 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_82",
      "name": "Karam Cut Resistant Gloves - Professional Series 7",
      "category": "Safety Products",
      "brand": "Karam",
      "image": "https://cdn.moglix.com/p/I/9/Q/d/MINI9QPXIGRUF-xxlarge.jpg",
      "rating": "3.7",
      "reviewsCount": 383,
      "price": "₹2,464",
      "oldPrice": "₹2,833",
      "discount": "13% OFF",
      "inStock": true,
      "stockQuantity": 58,
      "isDeal": false,
      "description": "High quality Karam Cut Resistant Gloves - Professional Series 7 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_83",
      "name": "Allen Cooper Reflective Jacket - Professional Series 8",
      "category": "Safety Products",
      "brand": "Allen Cooper",
      "image": "https://cdn.moglix.com/p/M5bLlMB9t7xEN-xxlarge.jpg",
      "rating": "3.8",
      "reviewsCount": 377,
      "price": "₹2,104",
      "oldPrice": "₹4,126",
      "discount": "49% OFF",
      "inStock": true,
      "stockQuantity": 109,
      "isDeal": false,
      "description": "High quality Allen Cooper Reflective Jacket - Professional Series 8 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_84",
      "name": "Liberty Cut Resistant Gloves - Professional Series 9",
      "category": "Safety Products",
      "brand": "Liberty",
      "image": "https://cdn.moglix.com/p/NgEwgNeKJkhty-xxlarge.jpg",
      "rating": "3.6",
      "reviewsCount": 213,
      "price": "₹1,726",
      "oldPrice": "₹3,083",
      "discount": "44% OFF",
      "inStock": true,
      "stockQuantity": 104,
      "isDeal": true,
      "description": "High quality Liberty Cut Resistant Gloves - Professional Series 9 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_85",
      "name": "Udyogi Reflective Jacket - Professional Series 10",
      "category": "Safety Products",
      "brand": "Udyogi",
      "image": "https://cdn.moglix.com/p/vLUbCFqQ0KVXL-xxlarge.jpg",
      "rating": "4.1",
      "reviewsCount": 207,
      "price": "₹4,136",
      "oldPrice": "₹5,170",
      "discount": "20% OFF",
      "inStock": true,
      "stockQuantity": 81,
      "isDeal": false,
      "description": "High quality Udyogi Reflective Jacket - Professional Series 10 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_86",
      "name": "Udyogi Safety Goggles - Professional Series 11",
      "category": "Safety Products",
      "brand": "Udyogi",
      "image": "https://cdn.moglix.com/p/tCvmNRdDRDHTc-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 446,
      "price": "₹1,850",
      "oldPrice": "₹2,984",
      "discount": "38% OFF",
      "inStock": true,
      "stockQuantity": 29,
      "isDeal": false,
      "description": "High quality Udyogi Safety Goggles - Professional Series 11 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_87",
      "name": "Udyogi Safety Goggles - Professional Series 12",
      "category": "Safety Products",
      "brand": "Udyogi",
      "image": "https://cdn.moglix.com/p/jighbkkj04iv2-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 178,
      "price": "₹861",
      "oldPrice": "₹1,149",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 91,
      "isDeal": false,
      "description": "High quality Udyogi Safety Goggles - Professional Series 12 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_88",
      "name": "Karam Safety Shoes Steel Toe - Professional Series 13",
      "category": "Safety Products",
      "brand": "Karam",
      "image": "https://cdn.moglix.com/p/hWbdBMdpH9nrm-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 230,
      "price": "₹3,754",
      "oldPrice": "₹4,876",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 36,
      "isDeal": false,
      "description": "High quality Karam Safety Shoes Steel Toe - Professional Series 13 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_89",
      "name": "Liberty Safety Shoes Steel Toe - Professional Series 14",
      "category": "Safety Products",
      "brand": "Liberty",
      "image": "https://cdn.moglix.com/p/bNMT893L8b0eA-xxlarge.jpg",
      "rating": "4.7",
      "reviewsCount": 428,
      "price": "₹3,395",
      "oldPrice": "₹4,353",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 67,
      "isDeal": false,
      "description": "High quality Liberty Safety Shoes Steel Toe - Professional Series 14 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_90",
      "name": "Karam Safety Goggles - Professional Series 15",
      "category": "Safety Products",
      "brand": "Karam",
      "image": "https://cdn.moglix.com/p/I/O/J/d/MINIOJ6NIU5C3-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 329,
      "price": "₹3,231",
      "oldPrice": "₹3,847",
      "discount": "16% OFF",
      "inStock": true,
      "stockQuantity": 14,
      "isDeal": false,
      "description": "High quality Karam Safety Goggles - Professional Series 15 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_91",
      "name": "Polycab Contactor - Professional Series 1",
      "category": "Electricals",
      "brand": "Polycab",
      "image": "https://cdn.moglix.com/p/6jwd5Pv0VurIl-xxlarge.jpeg",
      "rating": "3.8",
      "reviewsCount": 91,
      "price": "₹4,332",
      "oldPrice": "₹5,097",
      "discount": "15% OFF",
      "inStock": true,
      "stockQuantity": 14,
      "isDeal": false,
      "description": "High quality Polycab Contactor - Professional Series 1 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_92",
      "name": "Polycab Distribution Board - Professional Series 2",
      "category": "Electricals",
      "brand": "Polycab",
      "image": "https://cdn.moglix.com/p/aFknSYg75SnbT-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 383,
      "price": "₹1,766",
      "oldPrice": "₹2,523",
      "discount": "30% OFF",
      "inStock": true,
      "stockQuantity": 97,
      "isDeal": false,
      "description": "High quality Polycab Distribution Board - Professional Series 2 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_93",
      "name": "Polycab Socket 16A - Professional Series 3",
      "category": "Electricals",
      "brand": "Polycab",
      "image": "https://cdn.moglix.com/p/Wn4QQNq74VVWm-xxlarge.jpg",
      "rating": "4.9",
      "reviewsCount": 131,
      "price": "₹2,101",
      "oldPrice": "₹3,283",
      "discount": "36% OFF",
      "inStock": true,
      "stockQuantity": 98,
      "isDeal": false,
      "description": "High quality Polycab Socket 16A - Professional Series 3 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_94",
      "name": "Polycab Distribution Board - Professional Series 4",
      "category": "Electricals",
      "brand": "Polycab",
      "image": "https://cdn.moglix.com/p/9xRXIyQnglPhn-xxlarge.png",
      "rating": "4.8",
      "reviewsCount": 161,
      "price": "₹1,327",
      "oldPrice": "₹2,459",
      "discount": "46% OFF",
      "inStock": true,
      "stockQuantity": 109,
      "isDeal": false,
      "description": "High quality Polycab Distribution Board - Professional Series 4 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_95",
      "name": "Finolex Socket 16A - Professional Series 5",
      "category": "Electricals",
      "brand": "Finolex",
      "image": "https://cdn.moglix.com/p/4bHGnRmKkvGAC-xxlarge.jpg",
      "rating": "3.8",
      "reviewsCount": 292,
      "price": "₹1,816",
      "oldPrice": "₹2,188",
      "discount": "17% OFF",
      "inStock": true,
      "stockQuantity": 35,
      "isDeal": false,
      "description": "High quality Finolex Socket 16A - Professional Series 5 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_96",
      "name": "Finolex Socket 16A - Professional Series 6",
      "category": "Electricals",
      "brand": "Finolex",
      "image": "https://cdn.moglix.com/p/Q1fe3zRRo656d-xxlarge.png",
      "rating": "4.2",
      "reviewsCount": 145,
      "price": "₹1,339",
      "oldPrice": "₹1,762",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 88,
      "isDeal": false,
      "description": "High quality Finolex Socket 16A - Professional Series 6 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_97",
      "name": "Finolex Socket 16A - Professional Series 7",
      "category": "Electricals",
      "brand": "Finolex",
      "image": "https://cdn.moglix.com/p/s4gk6oodZJ3XN-xxlarge.jpg",
      "rating": "4.7",
      "reviewsCount": 113,
      "price": "₹1,795",
      "oldPrice": "₹3,521",
      "discount": "49% OFF",
      "inStock": true,
      "stockQuantity": 33,
      "isDeal": true,
      "description": "High quality Finolex Socket 16A - Professional Series 7 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_98",
      "name": "Legrand MCB 32A Double Pole - Professional Series 8",
      "category": "Electricals",
      "brand": "Legrand",
      "image": "https://cdn.moglix.com/p/Av1QWhn4AUEme-xxlarge.jpg",
      "rating": "4.7",
      "reviewsCount": 49,
      "price": "₹1,712",
      "oldPrice": "₹3,232",
      "discount": "47% OFF",
      "inStock": true,
      "stockQuantity": 24,
      "isDeal": false,
      "description": "High quality Legrand MCB 32A Double Pole - Professional Series 8 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_99",
      "name": "Anchor Modular Switch 10A - Professional Series 9",
      "category": "Electricals",
      "brand": "Anchor",
      "image": "https://cdn.moglix.com/p/YUHeCx1iUchWf-xxlarge.png",
      "rating": "3.9",
      "reviewsCount": 283,
      "price": "₹1,598",
      "oldPrice": "₹2,131",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 64,
      "isDeal": false,
      "description": "High quality Anchor Modular Switch 10A - Professional Series 9 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_100",
      "name": "Anchor Modular Switch 10A - Professional Series 10",
      "category": "Electricals",
      "brand": "Anchor",
      "image": "https://cdn.moglix.com/p/5REWsPSMUMiBi-xxlarge.jpg",
      "rating": "4.1",
      "reviewsCount": 188,
      "price": "₹773",
      "oldPrice": "₹1,289",
      "discount": "40% OFF",
      "inStock": true,
      "stockQuantity": 67,
      "isDeal": false,
      "description": "High quality Anchor Modular Switch 10A - Professional Series 10 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_101",
      "name": "Anchor MCB 32A Double Pole - Professional Series 11",
      "category": "Electricals",
      "brand": "Anchor",
      "image": "https://cdn.moglix.com/p/h5yJQxBIQHvoz-xxlarge.jpg",
      "rating": "4.9",
      "reviewsCount": 27,
      "price": "₹3,684",
      "oldPrice": "₹5,189",
      "discount": "29% OFF",
      "inStock": true,
      "stockQuantity": 88,
      "isDeal": false,
      "description": "High quality Anchor MCB 32A Double Pole - Professional Series 11 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_102",
      "name": "Polycab Capacitor - Professional Series 12",
      "category": "Electricals",
      "brand": "Polycab",
      "image": "https://cdn.moglix.com/p/yp41JOU1eVQhF-xxlarge.png",
      "rating": "4.0",
      "reviewsCount": 247,
      "price": "₹1,104",
      "oldPrice": "₹1,473",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 52,
      "isDeal": true,
      "description": "High quality Polycab Capacitor - Professional Series 12 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_103",
      "name": "Schneider Socket 16A - Professional Series 13",
      "category": "Electricals",
      "brand": "Schneider",
      "image": "https://cdn.moglix.com/p/kwAKNC4cgRw1H-xxlarge.jpg",
      "rating": "3.8",
      "reviewsCount": 339,
      "price": "₹1,020",
      "oldPrice": "₹1,458",
      "discount": "30% OFF",
      "inStock": true,
      "stockQuantity": 73,
      "isDeal": false,
      "description": "High quality Schneider Socket 16A - Professional Series 13 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_104",
      "name": "Polycab Contactor - Professional Series 14",
      "category": "Electricals",
      "brand": "Polycab",
      "image": "https://cdn.moglix.com/p/Cj69z2BmjY65n-xxlarge.jpg",
      "rating": "4.9",
      "reviewsCount": 302,
      "price": "₹2,056",
      "oldPrice": "₹3,672",
      "discount": "44% OFF",
      "inStock": true,
      "stockQuantity": 68,
      "isDeal": false,
      "description": "High quality Polycab Contactor - Professional Series 14 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_105",
      "name": "Polycab Contactor - Professional Series 15",
      "category": "Electricals",
      "brand": "Polycab",
      "image": "https://cdn.moglix.com/p/yUkmbc71iAA43-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 221,
      "price": "₹1,222",
      "oldPrice": "₹1,389",
      "discount": "12% OFF",
      "inStock": true,
      "stockQuantity": 31,
      "isDeal": false,
      "description": "High quality Polycab Contactor - Professional Series 15 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_106",
      "name": "Stanley Claw Hammer - Professional Series 1",
      "category": "Hardware",
      "brand": "Stanley",
      "image": "https://cdn.moglix.com/p/I/Q/T/d/MINIQTHBIGGC1-xxlarge.jpg",
      "rating": "3.7",
      "reviewsCount": 106,
      "price": "₹462",
      "oldPrice": "₹680",
      "discount": "32% OFF",
      "inStock": true,
      "stockQuantity": 75,
      "isDeal": false,
      "description": "High quality Stanley Claw Hammer - Professional Series 1 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_107",
      "name": "Facom Combination Pliers 8-Inch - Professional Series 2",
      "category": "Hardware",
      "brand": "Facom",
      "image": "https://cdn.moglix.com/p/I/W/6/d/MINIW6UHIGGC1-xxlarge.jpg",
      "rating": "4.9",
      "reviewsCount": 173,
      "price": "₹2,306",
      "oldPrice": "₹3,075",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 27,
      "isDeal": false,
      "description": "High quality Facom Combination Pliers 8-Inch - Professional Series 2 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_108",
      "name": "Venus Claw Hammer - Professional Series 3",
      "category": "Hardware",
      "brand": "Venus",
      "image": "https://cdn.moglix.com/p/otOS5V1rbB4cL-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 352,
      "price": "₹447",
      "oldPrice": "₹621",
      "discount": "28% OFF",
      "inStock": true,
      "stockQuantity": 19,
      "isDeal": false,
      "description": "High quality Venus Claw Hammer - Professional Series 3 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_109",
      "name": "Venus Spanner Set (12 Pcs) - Professional Series 4",
      "category": "Hardware",
      "brand": "Venus",
      "image": "https://cdn.moglix.com/p/YsFPiUC1VGhvC-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 111,
      "price": "₹514",
      "oldPrice": "₹677",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 47,
      "isDeal": false,
      "description": "High quality Venus Spanner Set (12 Pcs) - Professional Series 4 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_110",
      "name": "Stanley Adjustable Wrench - Professional Series 5",
      "category": "Hardware",
      "brand": "Stanley",
      "image": "https://cdn.moglix.com/p/FIzfuFEAjtq9j-xxlarge.jpg",
      "rating": "4.9",
      "reviewsCount": 20,
      "price": "₹1,751",
      "oldPrice": "₹2,736",
      "discount": "36% OFF",
      "inStock": true,
      "stockQuantity": 37,
      "isDeal": true,
      "description": "High quality Stanley Adjustable Wrench - Professional Series 5 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_111",
      "name": "Taparia Adjustable Wrench - Professional Series 6",
      "category": "Hardware",
      "brand": "Taparia",
      "image": "https://cdn.moglix.com/p/BrUM0LMU0FW7I-xxlarge.jpg",
      "rating": "4.0",
      "reviewsCount": 235,
      "price": "₹3,753",
      "oldPrice": "₹4,416",
      "discount": "15% OFF",
      "inStock": true,
      "stockQuantity": 98,
      "isDeal": false,
      "description": "High quality Taparia Adjustable Wrench - Professional Series 6 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_112",
      "name": "Facom Claw Hammer - Professional Series 7",
      "category": "Hardware",
      "brand": "Facom",
      "image": "https://cdn.moglix.com/p/SYY54qOFqGczz-xxlarge.jpg",
      "rating": "5.0",
      "reviewsCount": 322,
      "price": "₹2,311",
      "oldPrice": "₹3,853",
      "discount": "40% OFF",
      "inStock": true,
      "stockQuantity": 26,
      "isDeal": false,
      "description": "High quality Facom Claw Hammer - Professional Series 7 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_113",
      "name": "DeWalt Adjustable Wrench - Professional Series 8",
      "category": "Hardware",
      "brand": "DeWalt",
      "image": "https://cdn.moglix.com/p/iF0GwkugSPVAP-xxlarge.jpg",
      "rating": "3.7",
      "reviewsCount": 139,
      "price": "₹3,111",
      "oldPrice": "₹3,939",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 88,
      "isDeal": true,
      "description": "High quality DeWalt Adjustable Wrench - Professional Series 8 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_114",
      "name": "Venus Combination Pliers 8-Inch - Professional Series 9",
      "category": "Hardware",
      "brand": "Venus",
      "image": "https://cdn.moglix.com/p/tB2xnq527Sm5T-xxlarge.jpg",
      "rating": "3.5",
      "reviewsCount": 24,
      "price": "₹1,071",
      "oldPrice": "₹1,786",
      "discount": "40% OFF",
      "inStock": true,
      "stockQuantity": 16,
      "isDeal": true,
      "description": "High quality Venus Combination Pliers 8-Inch - Professional Series 9 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_115",
      "name": "Stanley Screwdriver Set - Professional Series 10",
      "category": "Hardware",
      "brand": "Stanley",
      "image": "https://cdn.moglix.com/p/AkGkmdoHJw4N6-xxlarge.jpg",
      "rating": "4.9",
      "reviewsCount": 101,
      "price": "₹1,351",
      "oldPrice": "₹1,689",
      "discount": "20% OFF",
      "inStock": true,
      "stockQuantity": 80,
      "isDeal": false,
      "description": "High quality Stanley Screwdriver Set - Professional Series 10 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_116",
      "name": "Venus Adjustable Wrench - Professional Series 11",
      "category": "Hardware",
      "brand": "Venus",
      "image": "https://cdn.moglix.com/p/K7V5dMbxgaiEK-xxlarge.jpg",
      "rating": "4.7",
      "reviewsCount": 323,
      "price": "₹2,327",
      "oldPrice": "₹3,278",
      "discount": "29% OFF",
      "inStock": true,
      "stockQuantity": 99,
      "isDeal": false,
      "description": "High quality Venus Adjustable Wrench - Professional Series 11 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_117",
      "name": "Taparia Spanner Set (12 Pcs) - Professional Series 12",
      "category": "Hardware",
      "brand": "Taparia",
      "image": "https://cdn.moglix.com/p/kVSULDMdLJPeI-xxlarge.jpg",
      "rating": "3.7",
      "reviewsCount": 149,
      "price": "₹4,499",
      "oldPrice": "₹5,487",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 54,
      "isDeal": false,
      "description": "High quality Taparia Spanner Set (12 Pcs) - Professional Series 12 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_118",
      "name": "Stanley Combination Pliers 8-Inch - Professional Series 13",
      "category": "Hardware",
      "brand": "Stanley",
      "image": "https://cdn.moglix.com/p/7pyz8f6sUfrxD-xxlarge.jpg",
      "rating": "4.8",
      "reviewsCount": 164,
      "price": "₹791",
      "oldPrice": "₹1,200",
      "discount": "34% OFF",
      "inStock": true,
      "stockQuantity": 43,
      "isDeal": false,
      "description": "High quality Stanley Combination Pliers 8-Inch - Professional Series 13 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_119",
      "name": "Stanley Measuring Tape 5m - Professional Series 14",
      "category": "Hardware",
      "brand": "Stanley",
      "image": "https://cdn.moglix.com/p/NCDrfFFNUEU59-xxlarge.jpg",
      "rating": "4.6",
      "reviewsCount": 285,
      "price": "₹3,759",
      "oldPrice": "₹4,641",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 107,
      "isDeal": false,
      "description": "High quality Stanley Measuring Tape 5m - Professional Series 14 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_120",
      "name": "DeWalt Allen Key Set - Professional Series 15",
      "category": "Hardware",
      "brand": "DeWalt",
      "image": "https://cdn.moglix.com/p/9jXxaTTxDt462-xxlarge.jpg",
      "rating": "3.9",
      "reviewsCount": 208,
      "price": "₹1,348",
      "oldPrice": "₹1,774",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 108,
      "isDeal": false,
      "description": "High quality DeWalt Allen Key Set - Professional Series 15 designed for industrial and home use. Features robust construction and reliable performance."
    },
    {
      "id": "prod_121",
      "name": "Bosch Hydraulic Cylinder 50mm Bore - Industrial Series 1",
      "category": "Hydraulic & Pneumatic",
      "brand": "Bosch",
      "image": "https://cdn.moglix.com/p/U5rCUWFnQ2YsN-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 87,
      "price": "₹4,250",
      "oldPrice": "₹5,800",
      "discount": "27% OFF",
      "inStock": true,
      "stockQuantity": 45,
      "isDeal": false,
      "description": "Heavy-duty Bosch hydraulic cylinder with 50mm bore diameter, designed for high-pressure industrial applications. Features precision-honed barrel and seal for leak-free operation."
    },
    {
      "id": "prod_122",
      "name": "Atlas Copco Air Compressor 1.5HP - Industrial Series 2",
      "category": "Hydraulic & Pneumatic",
      "brand": "Atlas Copco",
      "image": "https://cdn.moglix.com/p/UebVLIN9113Kg-xxlarge.jpg",
      "rating": "4.6",
      "reviewsCount": 154,
      "price": "₹12,500",
      "oldPrice": "₹16,200",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 28,
      "isDeal": true,
      "description": "Atlas Copco 1.5HP oil-free air compressor ideal for pneumatic tools, painting, and inflation. Delivers consistent pressure with low noise operation."
    },
    {
      "id": "prod_123",
      "name": "Parker Hannifin Hydraulic Valve 3/8 BSP - Industrial Series 3",
      "category": "Hydraulic & Pneumatic",
      "brand": "Parker Hannifin",
      "image": "https://cdn.moglix.com/p/JTOpd1KpH7kKt-xxlarge.png",
      "rating": "4.4",
      "reviewsCount": 62,
      "price": "₹3,180",
      "oldPrice": "₹4,100",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 67,
      "isDeal": false,
      "description": "Parker Hannifin directional control valve for hydraulic systems, 3/8 BSP connection, suitable for mobile and industrial machinery."
    },
    {
      "id": "prod_124",
      "name": "Festo Pneumatic Cylinder Double Acting 32mm - Industrial Series 4",
      "category": "Hydraulic & Pneumatic",
      "brand": "Festo",
      "image": "https://cdn.moglix.com/p/mVcnIu69b94pA-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 108,
      "price": "₹2,750",
      "oldPrice": "₹3,500",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 92,
      "isDeal": false,
      "description": "Festo double-acting pneumatic cylinder, 32mm bore, stroke length 100mm. ISO 15552 compliant with adjustable cushioning."
    },
    {
      "id": "prod_125",
      "name": "Hydraulic Hose Assembly 1/2 inch 1m - Industrial Series 5",
      "category": "Hydraulic & Pneumatic",
      "brand": "Gates",
      "image": "https://cdn.moglix.com/p/ZROQhxfDpItzs-xxlarge.jpg",
      "rating": "4.2",
      "reviewsCount": 73,
      "price": "₹980",
      "oldPrice": "₹1,350",
      "discount": "27% OFF",
      "inStock": true,
      "stockQuantity": 200,
      "isDeal": false,
      "description": "Gates hydraulic hose assembly, 1/2 inch ID, 1 metre length with 2-wire braid. Rated up to 210 bar working pressure."
    },
    {
      "id": "prod_126",
      "name": "Rexroth Hydraulic Pump Gear Type 18cc - Industrial Series 6",
      "category": "Hydraulic & Pneumatic",
      "brand": "Bosch Rexroth",
      "image": "https://cdn.moglix.com/p/WXHBytqNtGe5B-xxlarge.jpg",
      "rating": "4.7",
      "reviewsCount": 39,
      "price": "₹8,900",
      "oldPrice": "₹11,500",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 18,
      "isDeal": true,
      "description": "Bosch Rexroth gear hydraulic pump, 18cc/rev displacement, suitable for industrial presses, injection moulding, and CNC machinery."
    },
    {
      "id": "prod_127",
      "name": "Ingersoll Rand Pneumatic Impact Wrench 1/2 inch - Industrial Series 7",
      "category": "Hydraulic & Pneumatic",
      "brand": "Ingersoll Rand",
      "image": "https://cdn.moglix.com/p/NCDrfFFNUEU59-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 192,
      "price": "₹5,400",
      "oldPrice": "₹7,200",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 54,
      "isDeal": false,
      "description": "Ingersoll Rand pneumatic impact wrench, 1/2 inch drive, 610 Nm max torque. Lightweight composite housing for reduced operator fatigue."
    },
    {
      "id": "prod_128",
      "name": "SMC Solenoid Valve 5/2 Way 1/4 BSP - Industrial Series 8",
      "category": "Hydraulic & Pneumatic",
      "brand": "SMC",
      "image": "https://cdn.moglix.com/p/9jXxaTTxDt462-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 51,
      "price": "₹1,850",
      "oldPrice": "₹2,400",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 130,
      "isDeal": false,
      "description": "SMC 5/2-way single solenoid valve, 1/4 BSP, 24V DC coil. Compact and reliable for pneumatic circuit control."
    },
    {
      "id": "prod_129",
      "name": "Danfoss Hydraulic Pressure Gauge 0-400 Bar - Industrial Series 9",
      "category": "Hydraulic & Pneumatic",
      "brand": "Danfoss",
      "image": "https://cdn.moglix.com/p/UebVLIN9113Kg-xxlarge.jpg",
      "rating": "4.1",
      "reviewsCount": 44,
      "price": "₹1,200",
      "oldPrice": "₹1,600",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 165,
      "isDeal": false,
      "description": "Danfoss glycerine-filled pressure gauge, 0-400 bar range, 63mm dial, 1/4 NPT bottom connection. Suitable for high-vibration hydraulic environments."
    },
    {
      "id": "prod_130",
      "name": "Norgren FRL Unit Filter Regulator Lubricator 1/2 inch - Industrial Series 10",
      "category": "Hydraulic & Pneumatic",
      "brand": "Norgren",
      "image": "https://cdn.moglix.com/p/JTOpd1KpH7kKt-xxlarge.png",
      "rating": "4.4",
      "reviewsCount": 76,
      "price": "₹3,600",
      "oldPrice": "₹4,900",
      "discount": "27% OFF",
      "inStock": true,
      "stockQuantity": 83,
      "isDeal": false,
      "description": "Norgren modular FRL unit with filter, regulator, and lubricator combo, 1/2 inch port, 0-10 bar adjustment range."
    },
    {
      "id": "prod_131",
      "name": "Bosch Rexnord Hex Bolt M10x50 Grade 8.8 (Pack of 50) - Hardware Series 1",
      "category": "Hardware",
      "brand": "Bosch",
      "image": "https://cdn.moglix.com/p/mVcnIu69b94pA-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 312,
      "price": "₹560",
      "oldPrice": "₹720",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 500,
      "isDeal": false,
      "description": "Grade 8.8 hex bolts M10x50mm, zinc-plated for corrosion resistance. Pack of 50 pieces. Suitable for structural and mechanical assemblies."
    },
    {
      "id": "prod_132",
      "name": "Fischer Concrete Anchor Bolt M12 (Pack of 10) - Hardware Series 2",
      "category": "Hardware",
      "brand": "Fischer",
      "image": "https://cdn.moglix.com/p/ZROQhxfDpItzs-xxlarge.jpg",
      "rating": "4.6",
      "reviewsCount": 228,
      "price": "₹890",
      "oldPrice": "₹1,100",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 420,
      "isDeal": false,
      "description": "Fischer torque-controlled expansion anchor M12, suitable for concrete, solid brick, and natural stone. Pack of 10 anchors with nuts and washers."
    },
    {
      "id": "prod_133",
      "name": "Stanley Heavy Duty Butt Hinge 4 inch Stainless Steel (Pair) - Hardware Series 3",
      "category": "Hardware",
      "brand": "Stanley",
      "image": "https://cdn.moglix.com/p/WXHBytqNtGe5B-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 145,
      "price": "₹420",
      "oldPrice": "₹560",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 385,
      "isDeal": false,
      "description": "Stanley stainless steel heavy-duty butt hinges, 4-inch, pair. Corrosion resistant finish, suitable for exterior doors and gates."
    },
    {
      "id": "prod_134",
      "name": "Godrej Padlock 50mm Hardened Steel Shackle - Hardware Series 4",
      "category": "Hardware",
      "brand": "Godrej",
      "image": "https://cdn.moglix.com/p/NCDrfFFNUEU59-xxlarge.jpg",
      "rating": "4.7",
      "reviewsCount": 497,
      "price": "₹680",
      "oldPrice": "₹950",
      "discount": "28% OFF",
      "inStock": true,
      "stockQuantity": 290,
      "isDeal": true,
      "description": "Godrej 50mm padlock with hardened boron-alloy shackle and double-locking mechanism. 3 keys included. Weather-resistant for outdoor use."
    },
    {
      "id": "prod_135",
      "name": "Hilti HEX-L Self-Drilling Screw 4.8x19mm (Box of 500) - Hardware Series 5",
      "category": "Hardware",
      "brand": "Hilti",
      "image": "https://cdn.moglix.com/p/9jXxaTTxDt462-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 183,
      "price": "₹1,250",
      "oldPrice": "₹1,700",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 600,
      "isDeal": false,
      "description": "Hilti HEX-L self-drilling screws 4.8x19mm for steel-to-steel fastening. Box of 500. Hardened tip drills through up to 2mm steel without pre-drilling."
    },
    {
      "id": "prod_136",
      "name": "Rawlplug Nylon Wall Plug 8mm (Pack of 100) - Hardware Series 6",
      "category": "Hardware",
      "brand": "Rawlplug",
      "image": "https://cdn.moglix.com/p/UebVLIN9113Kg-xxlarge.jpg",
      "rating": "4.3",
      "reviewsCount": 254,
      "price": "₹220",
      "oldPrice": "₹320",
      "discount": "31% OFF",
      "inStock": true,
      "stockQuantity": 800,
      "isDeal": false,
      "description": "Rawlplug nylon frame fixings 8mm diameter, pack of 100. Universal use in concrete, brick, and hollow tiles. Enhanced anti-rotation ribs."
    },
    {
      "id": "prod_137",
      "name": "MS Steel Angle Bracket 75x75mm Zinc Plated (Pack of 4) - Hardware Series 7",
      "category": "Hardware",
      "brand": "Generic",
      "image": "https://cdn.moglix.com/p/JTOpd1KpH7kKt-xxlarge.png",
      "rating": "4.2",
      "reviewsCount": 119,
      "price": "₹380",
      "oldPrice": "₹500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 350,
      "isDeal": false,
      "description": "Mild steel angle brackets 75x75mm, zinc-plated finish, 3mm thickness. Ideal for shelving, framing, and structural support. Pack of 4 with screws included."
    },
    {
      "id": "prod_138",
      "name": "DeWalt Wood Screw PH2 4.5x50mm (Pack of 200) - Hardware Series 8",
      "category": "Hardware",
      "brand": "DeWalt",
      "image": "https://cdn.moglix.com/p/mVcnIu69b94pA-xxlarge.jpg",
      "rating": "4.6",
      "reviewsCount": 331,
      "price": "₹750",
      "oldPrice": "₹980",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 700,
      "isDeal": false,
      "description": "DeWalt premium wood screws, PH2 pozidrive, 4.5x50mm, zinc yellow passivated. Coarse thread for superior wood grip. Pack of 200."
    },
    {
      "id": "prod_139",
      "name": "Kenco Stainless Steel Hex Nuts M8 DIN 934 (Pack of 100) - Hardware Series 9",
      "category": "Hardware",
      "brand": "Kenco",
      "image": "https://cdn.moglix.com/p/ZROQhxfDpItzs-xxlarge.jpg",
      "rating": "4.4",
      "reviewsCount": 167,
      "price": "₹490",
      "oldPrice": "₹640",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 460,
      "isDeal": false,
      "description": "Stainless steel A2 hex nuts M8, DIN 934 standard. Pack of 100. Corrosion resistant for outdoor, marine, and food industry use."
    },
    {
      "id": "prod_140",
      "name": "Hettich Drawer Slide Full Extension 400mm (Pair) - Hardware Series 10",
      "category": "Hardware",
      "brand": "Hettich",
      "image": "https://cdn.moglix.com/p/WXHBytqNtGe5B-xxlarge.jpg",
      "rating": "4.5",
      "reviewsCount": 241,
      "price": "₹1,100",
      "oldPrice": "₹1,480",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 215,
      "isDeal": true,
      "description": "Hettich full-extension ball-bearing drawer slides, 400mm length, 35kg load capacity. Soft-close mechanism included. Pair, with mounting screws."
    },

    // ─── NiceDeal Enterprises Products (migrated from nicedealonline.com) ───

    // — Dahua IP CCTV Cameras —
    {
      "id": "prod_141",
      "name": "Dahua IP 2MP Dome H.265+ Network CCTV (DH-IPC-HDW1230T2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/nicedeal/fa1b6a_8e307d54b61048719bee187a7ed84a35_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 87,
      "price": "₹1,950",
      "oldPrice": "₹2,400",
      "discount": "19% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["IP Camera", "Dome", "H.265+", "2MP", "Indoor"],
      "sku": "DH-IPC-HDW1230T2",
      "description": "Dahua IP 2MP Dome H.265+ Network Indoor CCTV Camera. Features H.265+ codec, IR night vision up to 30m, IP67 waterproof rating, and PoE support. Ideal for indoor surveillance applications."
    },
    {
      "id": "prod_142",
      "name": "Dahua IP 2MP Bullet H.265+ Network CCTV (DH-IPC-HFW1230TL2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/nicedeal/fa1b6a_9a4581eb58ab491fa47fb75c949a237c_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 112,
      "price": "₹1,800",
      "oldPrice": "₹2,200",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 45,
      "isDeal": false,
      "tags": ["IP Camera", "Bullet", "H.265+", "2MP", "Outdoor"],
      "sku": "DH-IPC-HFW1230TL2",
      "description": "Dahua IP 2MP Bullet H.265+ Network Outdoor CCTV Camera with 30m IR night vision, IP67 waterproof protection, PoE support, and wide dynamic range for outdoor surveillance."
    },
    {
      "id": "prod_143",
      "name": "Dahua IP 2MP Hybrid Dome CCTV with MIC (IPC-HDW1239T2-A-IL)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/nicedeal/fa1b6a_ee3f4d2d0fcf4de9abd77e809cdddc13_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 156,
      "price": "₹2,450",
      "oldPrice": "₹3,100",
      "discount": "21% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": true,
      "tags": ["IP Camera", "Night Color", "Full-Time Color", "2MP", "Built-in MIC"],
      "sku": "IPC-HDW1239T2-A-IL",
      "description": "Dahua 2MP Full Color Night Vision IP Dome Camera with built-in microphone. Features always-on full-color imaging even in low light using smart dual-light technology, ideal for color surveillance 24/7."
    },
    {
      "id": "prod_144",
      "name": "Dahua IP 2MP Hybrid Bullet CCTV with MIC (IPC-HFW1239TL2-A-IL)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/nicedeal/fa1b6a_1a7e0a7c91fb40dbbc4f0f277e8b337b_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 98,
      "price": "₹2,450",
      "oldPrice": "₹3,100",
      "discount": "21% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["IP Camera", "Night Color", "Full-Time Color", "2MP", "Bullet", "Built-in MIC"],
      "sku": "IPC-HFW1239TL2-A-IL",
      "description": "Dahua 2MP Full Color Night Vision IP Bullet Camera with built-in MIC. Smart dual-light technology provides full-color images 24/7 for outdoor applications."
    },
    {
      "id": "prod_145",
      "name": "Dahua IP 4MP Dome Network CCTV with MIC (DH-IPC-HDW1430T2-A)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.6",
      "reviewsCount": 203,
      "price": "₹2,800",
      "oldPrice": "₹3,500",
      "discount": "20% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["IP Camera", "4MP", "Dome", "Built-in MIC", "H.265+"],
      "sku": "DH-IPC-HDW1430T2-A",
      "description": "Dahua 4MP IP Dome Network Camera with built-in microphone, H.265+ compression, IR night vision up to 30m, and IP67 weather resistance for indoor surveillance."
    },
    {
      "id": "prod_146",
      "name": "Dahua IP 4MP Bullet CCTV with MIC (DH-IPC-HFW1430TL2-A)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.5",
      "reviewsCount": 174,
      "price": "₹2,850",
      "oldPrice": "₹3,600",
      "discount": "21% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["IP Camera", "4MP", "Bullet", "Built-in MIC", "Outdoor"],
      "sku": "DH-IPC-HFW1430TL2-A",
      "description": "Dahua 4MP IP Bullet Camera with built-in microphone for outdoor use, featuring H.265+ encoding, smart IR up to 30m, and IP67 weatherproof housing."
    },
    {
      "id": "prod_147",
      "name": "Dahua IP 4MP Hybrid Dome CCTV with MIC (IPC-HDW1439T2-A-IL)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.7",
      "reviewsCount": 231,
      "price": "₹3,350",
      "oldPrice": "₹4,200",
      "discount": "20% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": true,
      "tags": ["IP Camera", "Night Color", "4MP", "Dome", "Full-Time Color", "Built-in MIC"],
      "sku": "IPC-HDW1439T2-A-IL",
      "description": "Dahua 4MP Full Color Night Vision Hybrid Dome Camera with built-in MIC. Smart dual-light for 24/7 full-color surveillance, ideal for entrances and lobbies."
    },
    {
      "id": "prod_148",
      "name": "Dahua IP 4MP 50mtrs Varifocal Bullet CCTV (IPC-HFW1431TP-ZS)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.4",
      "reviewsCount": 89,
      "price": "₹9,450",
      "oldPrice": "₹12,000",
      "discount": "21% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["IP Camera", "Varifocal", "4MP", "50m IR", "Project Series"],
      "sku": "IPC-HFW1431TP-ZS",
      "description": "Dahua 4MP Varifocal Bullet Network Camera with motorized zoom lens (2.8–12mm), 50m IR night vision, H.265+ compression, and IP67 waterproof rating for flexible installation."
    },
    {
      "id": "prod_149",
      "name": "Dahua IP 4MP 25x Starlight IR PTZ Camera (DH-SD49425GB-HNR)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/ip-camera.png",
      "rating": "4.8",
      "reviewsCount": 42,
      "price": "₹34,500",
      "oldPrice": "₹44,000",
      "discount": "22% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["PTZ Camera", "4MP", "25x Optical Zoom", "Starlight", "Project Series"],
      "sku": "DH-SD49425GB-HNR",
      "description": "Dahua 4MP 25x Optical Zoom Starlight IR PTZ Camera with AI features. 100m IR night vision, H.265+ codec, IP66 waterproof, auto-tracking, and smart motion detection for large area surveillance."
    },

    // — Dahua NVRs —
    {
      "id": "prod_150",
      "name": "Dahua 4 Channel H.265+ NVR (DH-NVR1104HS-S3/H)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Dahua",
      "image": "/assets/images/nvr.png",
      "rating": "4.3",
      "reviewsCount": 145,
      "price": "₹3,650",
      "oldPrice": "₹4,800",
      "discount": "24% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["NVR", "4 Channel", "H.265+", "Compact"],
      "sku": "DH-NVR1104HS-S3/H",
      "description": "Dahua 4-Channel Compact Network Video Recorder with H.265+ encoding, supports up to 4MP resolution per channel, 1 SATA bay, and easy plug-and-play setup."
    },
    {
      "id": "prod_151",
      "name": "Dahua 8 Channel H.265+ NVR (DH-NVR1108HS-S3/H)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Dahua",
      "image": "/assets/images/nvr.png",
      "rating": "4.4",
      "reviewsCount": 189,
      "price": "₹4,250",
      "oldPrice": "₹5,500",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["NVR", "8 Channel", "H.265+"],
      "sku": "DH-NVR1108HS-S3/H",
      "description": "Dahua 8-Channel H.265+ Network Video Recorder supporting up to 8MP per channel, 1 SATA bay (up to 8TB), HDMI + VGA output, and remote access via mobile app."
    },
    {
      "id": "prod_152",
      "name": "Dahua 16 Channel H.265+ NVR (DHI-NVR2116HS-S3)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Dahua",
      "image": "/assets/images/nicedeal/fa1b6a_3e07122560a94a99b5ee63a2d19d4b38_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 213,
      "price": "₹6,970",
      "oldPrice": "₹9,000",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["NVR", "16 Channel", "H.265+", "4K"],
      "sku": "DHI-NVR2116HS-S3",
      "description": "Dahua 16-Channel H.265+ 4K Network Video Recorder with 1 SATA bay, smart detection, 4K HDMI output, and ONVIF compatibility for mixed camera environments."
    },
    {
      "id": "prod_153",
      "name": "Dahua Pro 16 Channel 2 SATA H.265+ NVR (DHI-NVR4216-4KS2/L)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Dahua",
      "image": "/assets/images/nicedeal/fa1b6a_f5505ed5eabd4b898d132f5a1d9b785c_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 178,
      "price": "₹11,000",
      "oldPrice": "₹14,500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 18,
      "isDeal": false,
      "tags": ["NVR", "16 Channel", "2 SATA", "H.265+", "4K", "Pro"],
      "sku": "DHI-NVR4216-4KS2/L",
      "description": "Dahua Pro 16-Channel 4K NVR with 2 SATA bays (up to 16TB), H.265+ smart coding, perimeter protection AI, face detection, and smart home integration."
    },
    {
      "id": "prod_154",
      "name": "Dahua Pro 32 Channel 2 SATA H.265+ NVR (NVR4232-4KS2/L)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Dahua",
      "image": "/assets/images/nvr.png",
      "rating": "4.7",
      "reviewsCount": 94,
      "price": "₹19,500",
      "oldPrice": "₹25,000",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 12,
      "isDeal": true,
      "tags": ["NVR", "32 Channel", "2 SATA", "H.265+", "4K", "Pro"],
      "sku": "NVR4232-4KS2/L",
      "description": "Dahua Pro 32-Channel 4K H.265+ NVR with 2 SATA bays, AI-powered smart detection (face, vehicle), perimeter protection, and simultaneous HDMI + VGA outputs."
    },
    {
      "id": "prod_155",
      "name": "Dahua 64 Channel 4 SATA H.265+ ANPR NVR (DHI-NVR5464-EI)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Dahua",
      "image": "/assets/images/nvr.png",
      "rating": "4.8",
      "reviewsCount": 37,
      "price": "₹37,500",
      "oldPrice": "₹48,000",
      "discount": "22% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["NVR", "64 Channel", "4 SATA", "ANPR", "AI", "Project Series"],
      "sku": "DHI-NVR5464-EI",
      "description": "Dahua 64-Channel AI NVR with ANPR (license plate recognition), face recognition, 4 SATA bays (up to 32TB), H.265+ compression, and enterprise-grade AI analytics for large installations."
    },

    // — CP Plus IP CCTV Cameras —
    {
      "id": "prod_156",
      "name": "STQC | CP Plus 2MP Network IP Dome Camera (30m, PoE, IP67) | CP-UNC-DA21L3C-Q",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/nicedeal/fa1b6a_6d28433add8648b1880deb5b59fde3dc_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 267,
      "price": "₹2,850",
      "oldPrice": "₹3,600",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 82,
      "isDeal": false,
      "tags": ["IP Camera", "2MP", "Dome", "PoE", "IP67", "STQC Certified", "Built-in MIC"],
      "sku": "CP-UNC-DA21L3C-Q",
      "description": "STQC certified CP Plus 2MP IP Dome Camera with PoE, IR night vision up to 30m, IP67 weatherproof, H.265+ compression, and built-in microphone for indoor/outdoor surveillance."
    },
    {
      "id": "prod_157",
      "name": "STQC | CP Plus 2MP Network IP Bullet Camera (30m, PoE) | CP-UNC-TA21L3C-Q",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.3",
      "reviewsCount": 198,
      "price": "₹2,900",
      "oldPrice": "₹3,700",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 64,
      "isDeal": false,
      "tags": ["IP Camera", "2MP", "Bullet", "PoE", "STQC Certified", "Built-in MIC"],
      "sku": "CP-UNC-TA21L3C-Q",
      "description": "STQC certified CP Plus 2MP IP Bullet Camera with PoE, 30m IR range, IP67 protection, H.265+ codec, and built-in microphone for perimeter security."
    },
    {
      "id": "prod_158",
      "name": "STQC | CP Plus 2MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA21L3C-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.6",
      "reviewsCount": 312,
      "price": "₹3,100",
      "oldPrice": "₹4,000",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 95,
      "isDeal": true,
      "tags": ["IP Camera", "Night Color", "2MP", "Full-Color", "Dome", "STQC Certified"],
      "sku": "CP-UNC-DA21L3C-LQ",
      "description": "STQC certified CP Plus 2MP Full Color Night Vision IP Dome Camera. Smart LED technology delivers vivid color images 24/7, even in pitch darkness. Includes built-in MIC, PoE, and IP67 protection."
    },
    {
      "id": "prod_159",
      "name": "STQC | CP Plus 4MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA41L3C-D-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/nicedeal/fa1b6a_97ea90fa207044ae82ce1970ed4db5eb_mv2.jpg",
      "rating": "4.7",
      "reviewsCount": 289,
      "price": "₹3,850",
      "oldPrice": "₹5,000",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 73,
      "isDeal": false,
      "tags": ["IP Camera", "Night Color", "4MP", "Full-Color", "Dome", "STQC Certified"],
      "sku": "CP-UNC-DA41L3C-D-LQ",
      "description": "STQC certified CP Plus 4MP Full Color Night Vision IP Dome Camera with dual-light smart LED for 24/7 vivid color surveillance, built-in MIC, PoE, and IP67 weatherproofing."
    },
    {
      "id": "prod_160",
      "name": "STQC | CP Plus 6MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA61L3C-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.8",
      "reviewsCount": 178,
      "price": "₹5,300",
      "oldPrice": "₹6,800",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 41,
      "isDeal": true,
      "tags": ["IP Camera", "Night Color", "6MP", "Full-Color", "Dome", "STQC Certified"],
      "sku": "CP-UNC-DA61L3C-LQ",
      "description": "STQC certified CP Plus 6MP Full Color IP Dome Camera with dual-LED night color technology, H.265+ compression, built-in MIC, PoE, and IP67 weatherproofing for premium 6MP surveillance."
    },
    {
      "id": "prod_161",
      "name": "STQC | CP Plus 4 MP Dual-Light Vandal Dome Camera | CP-UNC-VC41L5C-VMD-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.6",
      "reviewsCount": 134,
      "price": "₹7,350",
      "oldPrice": "₹9,500",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 28,
      "isDeal": false,
      "tags": ["IP Camera", "Night Color", "4MP", "Vandal Dome", "Dual-Light", "Project Series"],
      "sku": "CP-UNC-VC41L5C-VMD-LQ",
      "description": "STQC certified CP Plus 4MP Dual-Light Vandal Proof IP Dome Camera with smart IR + white light technology, IK10 vandal resistance, IP67 weatherproofing, and 50m IR range."
    },
    {
      "id": "prod_162",
      "name": "STQC | CP Plus IP 2MP 25x 100mtrs Network PTZ Camera | CP-UNP-D2521L10-DAQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/ip-camera.png",
      "rating": "4.7",
      "reviewsCount": 56,
      "price": "₹34,750",
      "oldPrice": "₹44,000",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 9,
      "isDeal": false,
      "tags": ["PTZ Camera", "2MP", "25x Optical Zoom", "100m IR", "Project Series"],
      "sku": "CP-UNP-D2521L10-DAQ",
      "description": "CP Plus 2MP 25x Optical Zoom PTZ Camera with 100m IR night vision, H.265+ compression, auto-tracking, IP66 weatherproofing, and wiper for outdoor long-range surveillance."
    },

    // — CP Plus NVRs —
    {
      "id": "prod_163",
      "name": "CP Plus 4 Channel Embedded NVR (CP-UNR-104F1)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.3",
      "reviewsCount": 321,
      "price": "₹4,750",
      "oldPrice": "₹6,000",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 56,
      "isDeal": false,
      "tags": ["NVR", "4 Channel", "H.265+", "ONVIF"],
      "sku": "CP-UNR-104F1",
      "description": "CP Plus 4-Channel Embedded Network Video Recorder supporting 4K resolution, H.265+ compression, 1 SATA bay, remote access via mobile app, and plug-and-play setup."
    },
    {
      "id": "prod_164",
      "name": "CP Plus 8 Channel Embedded NVR (CP-UNR-108F1)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.4",
      "reviewsCount": 287,
      "price": "₹5,450",
      "oldPrice": "₹7,000",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 43,
      "isDeal": false,
      "tags": ["NVR", "8 Channel", "H.265+", "4K"],
      "sku": "CP-UNR-108F1",
      "description": "CP Plus 8-Channel 4K NVR with H.265+ encoding, 1 SATA bay (up to 6TB), motion detection, HDMI + VGA outputs, and mobile app remote viewing."
    },
    {
      "id": "prod_165",
      "name": "CP Plus Pro 16 Channel 4K 2 SATA H.265+ NVR (CP-UNR-4K4162-V4)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.7",
      "reviewsCount": 198,
      "price": "₹11,500",
      "oldPrice": "₹15,000",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 24,
      "isDeal": true,
      "tags": ["NVR", "16 Channel", "4K", "2 SATA", "H.265+", "Best Seller"],
      "sku": "CP-UNR-4K4162-V4",
      "description": "CP Plus Pro 16-Channel 4K NVR with 2 SATA bays (up to 16TB), AI-powered smart analytics, face detection, perimeter protection, HDMI 4K output, and P2P remote access."
    },
    {
      "id": "prod_166",
      "name": "CP Plus Pro 32 Channel 4K 2 SATA H.265+ NVR (CP-UNR-4K4322-V4)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.8",
      "reviewsCount": 143,
      "price": "₹16,500",
      "oldPrice": "₹21,000",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 17,
      "isDeal": false,
      "tags": ["NVR", "32 Channel", "4K", "2 SATA", "H.265+", "Best Seller"],
      "sku": "CP-UNR-4K4322-V4",
      "description": "CP Plus Pro 32-Channel 4K H.265+ NVR with 2 SATA bays, AI smart detection, simultaneous 4K HDMI + VGA output, mobile app remote access, and ONVIF compatibility."
    },

    // — Honeywell NVRs —
    {
      "id": "prod_167",
      "name": "Honeywell 10 Channel 4K NVR | I-HNVR-1110",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nvr.png",
      "rating": "4.5",
      "reviewsCount": 87,
      "price": "₹8,250",
      "oldPrice": "₹11,000",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 22,
      "isDeal": false,
      "tags": ["NVR", "10 Channel", "4K", "Pro Series"],
      "sku": "I-HNVR-1110",
      "description": "Honeywell Pro Series 10-Channel 4K NVR with H.265+ compression, smart motion detection, HDMI 4K output, mobile remote access, and ONVIF compatibility for professional IP camera setups."
    },
    {
      "id": "prod_168",
      "name": "Honeywell 20 Channel 4K NVR | I-HNVR-1120",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nvr.png",
      "rating": "4.6",
      "reviewsCount": 112,
      "price": "₹9,650",
      "oldPrice": "₹13,000",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 18,
      "isDeal": false,
      "tags": ["NVR", "20 Channel", "4K", "Pro Series"],
      "sku": "I-HNVR-1120",
      "description": "Honeywell Pro Series 20-Channel 4K NVR with H.265+ encoding, smart analytics, dual HDMI output, and ONVIF support for enterprise IP security installations."
    },
    {
      "id": "prod_169",
      "name": "Honeywell 64 Channel 4-SATA 4K NVR | I-HPNVR-464",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nvr.png",
      "rating": "4.7",
      "reviewsCount": 68,
      "price": "₹57,500",
      "oldPrice": "₹75,000",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 7,
      "isDeal": false,
      "tags": ["NVR", "64 Channel", "4 SATA", "4K", "Project Series"],
      "sku": "I-HPNVR-464",
      "description": "Honeywell Project Series 64-Channel 4K NVR with 4 SATA bays (up to 32TB), AI smart analytics, face recognition, ANPR, dual HDMI 4K output for large enterprise surveillance."
    },
    {
      "id": "prod_170",
      "name": "Honeywell 256 Channel 16-SATA 4K NVR | I-HPNVR-16256",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nvr.png",
      "rating": "4.9",
      "reviewsCount": 23,
      "price": "₹2,48,500",
      "oldPrice": "₹3,20,000",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 3,
      "isDeal": false,
      "tags": ["NVR", "256 Channel", "16 SATA", "4K", "Enterprise", "Project Series"],
      "sku": "I-HPNVR-16256",
      "description": "Honeywell Enterprise-Grade 256-Channel 4K NVR with 16 SATA bays (up to 128TB), advanced AI analytics, face recognition, ANPR, RAID support, and redundant power supply for mission-critical installations."
    },

    // — Biometrics / Access Control —
    {
      "id": "prod_171",
      "name": "HIKVISION Face Access Terminal Biometric Attendance Machine | DS-K1T320EFWX",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Hikvision",
      "image": "/assets/images/biometric.png",
      "rating": "4.6",
      "reviewsCount": 234,
      "price": "₹6,450",
      "oldPrice": "₹8,500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 38,
      "isDeal": true,
      "tags": ["Biometric", "Face Recognition", "Attendance", "Access Control", "Best Seller"],
      "sku": "DS-K1T320EFWX",
      "description": "Hikvision Face Access Terminal with deep learning face recognition, fingerprint, card, and PIN verification. 7-inch touch screen, 2MP wide-angle camera, and supports 3,000 face records."
    },
    {
      "id": "prod_172",
      "name": "eSSL K30 Pro Identix Fingerprint Time Attendance with Access Control",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "eSSL",
      "image": "/assets/images/biometric.png",
      "rating": "4.4",
      "reviewsCount": 312,
      "price": "₹5,150",
      "oldPrice": "₹6,800",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 55,
      "isDeal": false,
      "tags": ["Biometric", "Fingerprint", "Attendance", "Access Control", "Best Seller"],
      "sku": "eSSL-K30-PRO",
      "description": "eSSL K30 Pro Fingerprint Time & Attendance with Access Control. Stores 2,000 fingerprints, 30,000 records. Supports RS232/485 and TCP/IP connectivity, with USB pen drive data download."
    },
    {
      "id": "prod_173",
      "name": "Realtime RS9n Biometric Attendance Machine with Access Control",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.5",
      "reviewsCount": 289,
      "price": "₹4,950",
      "oldPrice": "₹6,500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 67,
      "isDeal": false,
      "tags": ["Biometric", "Fingerprint", "Attendance", "Access Control", "Best Seller"],
      "sku": "Realtime-RS9n",
      "description": "Realtime RS9n Fingerprint Biometric Attendance Machine with access control. Stores 3,000 fingerprints and 1,00,000 attendance records. TCP/IP, RS232/485 connectivity."
    },
    {
      "id": "prod_174",
      "name": "Realtime T304F Mini Face Attendance System with Access Control",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.6",
      "reviewsCount": 167,
      "price": "₹8,750",
      "oldPrice": "₹11,500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 31,
      "isDeal": false,
      "tags": ["Biometric", "Face Recognition", "Attendance", "Access Control", "Mini"],
      "sku": "Realtime-T304F",
      "description": "Realtime T304F Face Attendance System with 5-inch touch screen, IR face recognition, fingerprint, card, and PIN. Stores 3,000 face templates for accurate contactless attendance."
    },
    {
      "id": "prod_175",
      "name": "eSSL F22 Biometric Fingerprint & RFID Time Attendance and Access Control Terminal",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "eSSL",
      "image": "/assets/images/biometric.png",
      "rating": "4.5",
      "reviewsCount": 198,
      "price": "₹8,750",
      "oldPrice": "₹11,500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 44,
      "isDeal": false,
      "tags": ["Biometric", "Fingerprint", "RFID", "Wi-Fi", "Attendance", "Access Control"],
      "sku": "eSSL-F22",
      "description": "eSSL F22 Wi-Fi enabled Fingerprint & RFID Biometric Attendance Terminal. Supports 3,000 fingerprints, 1,00,000 transactions. Built-in Wi-Fi for wireless data synchronization."
    },
    {
      "id": "prod_176",
      "name": "Realtime T501 Mini Face with Finger Attendance and Access Control System",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.7",
      "reviewsCount": 223,
      "price": "₹11,450",
      "oldPrice": "₹15,000",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 26,
      "isDeal": true,
      "tags": ["Biometric", "Face Recognition", "Fingerprint", "Attendance", "Best Seller"],
      "sku": "Realtime-T501",
      "description": "Realtime T501 Mini Face + Fingerprint Attendance System with 5-inch color touch screen, IR dual-camera face recognition, card reader, and built-in access control relay for door lock integration."
    },
    {
      "id": "prod_177",
      "name": "Realtime T502-L1 Aadhaar-enabled Biometric Attendance System",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.8",
      "reviewsCount": 145,
      "price": "₹21,500",
      "oldPrice": "₹28,000",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 14,
      "isDeal": false,
      "tags": ["Biometric", "Aadhaar", "Fingerprint", "Government", "L1 Certified", "Best Seller"],
      "sku": "Realtime-T502-L1",
      "description": "Realtime T502-L1 Aadhaar-enabled Biometric Attendance System with L1 certified fingerprint sensor, STQC certified, suitable for government attendance applications under NIC/AEBAS."
    },
    {
      "id": "prod_178",
      "name": "eSSL X990 Biometric Fingerprint / Card Time & Attendance & Access Control System",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "eSSL",
      "image": "/assets/images/biometric.png",
      "rating": "4.6",
      "reviewsCount": 178,
      "price": "₹11,750",
      "oldPrice": "₹15,500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 32,
      "isDeal": false,
      "tags": ["Biometric", "Fingerprint", "Card", "Attendance", "Access Control"],
      "sku": "eSSL-X990",
      "description": "eSSL X990 Multi-Verification Biometric System supporting fingerprint, RFID card, and PIN. Large 5,000 fingerprint capacity, 1,00,000 records, Wiegand output for third-party access control integration."
    },

    // — PoE Switches & IT Networking —
    {
      "id": "prod_179",
      "name": "CP Plus 4 Port PoE Switch with 2 x 10/100Mbps Uplink (CP-ANW-HP4H2-N65)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "CP Plus",
      "image": "/assets/images/network-switch.png",
      "rating": "4.3",
      "reviewsCount": 267,
      "price": "₹1,450",
      "oldPrice": "₹1,900",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 112,
      "isDeal": false,
      "tags": ["PoE Switch", "4 Port", "IP Camera", "Networking"],
      "sku": "CP-ANW-HP4H2-N65",
      "description": "CP Plus 4-Port PoE Switch with 2 uplink ports, 65W total PoE budget, IEEE 802.3af/at compliant, plug-and-play setup for IP cameras without separate power adapters."
    },
    {
      "id": "prod_180",
      "name": "CP Plus 8 Port PoE Switch (CP-DNW-HPU8H2-96)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "CP Plus",
      "image": "/assets/images/network-switch.png",
      "rating": "4.4",
      "reviewsCount": 312,
      "price": "₹1,950",
      "oldPrice": "₹2,600",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 89,
      "isDeal": false,
      "tags": ["PoE Switch", "8 Port", "IP Camera", "Networking"],
      "sku": "CP-DNW-HPU8H2-96",
      "description": "CP Plus 8-Port PoE Switch, 96W PoE budget, IEEE 802.3af/at compliant, with 2 uplink ports. Ideal for powering 8 IP cameras in commercial CCTV installations."
    },
    {
      "id": "prod_181",
      "name": "CP Plus 8 Port Giga PoE Switch (CP-ANW-GPU8G2-N12)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "CP Plus",
      "image": "/assets/images/network-switch.png",
      "rating": "4.5",
      "reviewsCount": 198,
      "price": "₹3,450",
      "oldPrice": "₹4,500",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 64,
      "isDeal": false,
      "tags": ["PoE Switch", "Gigabit", "8 Port", "IP Camera"],
      "sku": "CP-ANW-GPU8G2-N12",
      "description": "CP Plus 8-Port Gigabit PoE Switch with 120W total PoE budget, 1000Mbps per port, IEEE 802.3af/at compliant, VLAN support for high-bandwidth IP camera networks."
    },
    {
      "id": "prod_182",
      "name": "CP Plus 16 Port Giga PoE Switch with SFP Port (CP-DNW-GPU16G2F2-20)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "CP Plus",
      "image": "/assets/images/nicedeal/fa1b6a_3e07122560a94a99b5ee63a2d19d4b38_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 134,
      "price": "₹10,450",
      "oldPrice": "₹13,500",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 31,
      "isDeal": false,
      "tags": ["PoE Switch", "Gigabit", "16 Port", "SFP", "Managed"],
      "sku": "CP-DNW-GPU16G2F2-20",
      "description": "CP Plus 16-Port Gigabit PoE+ Switch with 2 SFP uplink ports, 200W PoE budget, VLAN, QoS, and IEEE 802.3af/at support for enterprise IP camera and access point deployments."
    },
    {
      "id": "prod_183",
      "name": "CP Plus 24 Port Giga PoE Switch (CP-ANW-GPU24F2-N30)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "CP Plus",
      "image": "/assets/images/nicedeal/fa1b6a_f5505ed5eabd4b898d132f5a1d9b785c_mv2.jpg",
      "rating": "4.7",
      "reviewsCount": 89,
      "price": "₹13,250",
      "oldPrice": "₹17,000",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 19,
      "isDeal": false,
      "tags": ["PoE Switch", "Gigabit", "24 Port", "Enterprise"],
      "sku": "CP-ANW-GPU24F2-N30",
      "description": "CP Plus 24-Port Gigabit PoE Switch with 300W total PoE budget, 2 SFP ports, IEEE 802.3at (PoE+) standard, VLAN and QoS for large-scale IP CCTV and Wi-Fi AP deployments."
    },

    // — Cables & Accessories —
    {
      "id": "prod_184",
      "name": "CP Plus CAT6 UTP Copper Cable (Loose, per metre)",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "CP Plus",
      "image": "/assets/images/cat6-cable.png",
      "rating": "4.2",
      "reviewsCount": 523,
      "price": "₹39",
      "oldPrice": "₹55",
      "discount": "29% OFF",
      "inStock": true,
      "stockQuantity": 5000,
      "isDeal": false,
      "tags": ["CAT6", "UTP", "Cable", "Networking", "CCTV"],
      "sku": "CP-CAT6-LOOSE",
      "description": "CP Plus CAT6 UTP Copper Cable (sold per metre), 23AWG pure copper conductor, 250MHz bandwidth, suitable for IP CCTV, PoE, and LAN installations."
    },
    {
      "id": "prod_185",
      "name": "CP Plus CAT6 100mtrs UTP Copper Cable (CP-EUT-6TGL23-100)",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "CP Plus",
      "image": "/assets/images/cat6-cable.png",
      "rating": "4.3",
      "reviewsCount": 312,
      "price": "₹3,750",
      "oldPrice": "₹4,800",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 145,
      "isDeal": false,
      "tags": ["CAT6", "UTP", "Copper", "100m", "Networking"],
      "sku": "CP-EUT-6TGL23-100",
      "description": "CP Plus 100 metre CAT6 UTP Pure Copper Cable box, 23AWG, 250MHz, for IP CCTV, LAN, and PoE applications. Meets TIA/EIA-568-C.2 standards."
    },
    {
      "id": "prod_186",
      "name": "D-Link CAT6 UTP Pure Copper 100mtrs Cable",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "D-Link",
      "image": "/assets/images/nicedeal/fa1b6a_6d28433add8648b1880deb5b59fde3dc_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 287,
      "price": "₹4,450",
      "oldPrice": "₹5,800",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 98,
      "isDeal": false,
      "tags": ["CAT6", "UTP", "Copper", "100m", "D-Link"],
      "sku": "D-Link-CAT6-100M",
      "description": "D-Link CAT6 Pure Copper 100m UTP LAN Cable, 23AWG, supports Gigabit Ethernet and PoE. Meets TIA-568-C.2 Category 6 performance standards."
    },
    {
      "id": "prod_187",
      "name": "D-Link Premium RJ-45 Connector (Pack of 100)",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "D-Link",
      "image": "/assets/images/cat6-cable.png",
      "rating": "4.1",
      "reviewsCount": 445,
      "price": "₹5",
      "oldPrice": "₹8",
      "discount": "38% OFF",
      "inStock": true,
      "stockQuantity": 10000,
      "isDeal": false,
      "tags": ["RJ45", "Connector", "CAT6", "Networking", "CCTV Accessory"],
      "sku": "D-Link-RJ45-CON",
      "description": "D-Link Premium RJ-45 connector, 8P8C, gold plated contacts for reliable network connections. Compatible with CAT5e, CAT6 cables. Sold per piece."
    },

    // — CCTV Accessories —
    {
      "id": "prod_188",
      "name": "PVC Junction Box (5\"x5\") for CCTV",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "ZVision",
      "image": "/assets/images/camera.png",
      "rating": "4.0",
      "reviewsCount": 678,
      "price": "₹45",
      "oldPrice": "₹65",
      "discount": "31% OFF",
      "inStock": true,
      "stockQuantity": 3000,
      "isDeal": false,
      "tags": ["CCTV Accessory", "Junction Box", "PVC", "Mounting"],
      "sku": "PVC-JB-5x5",
      "description": "PVC Junction Box 5\"x5\" for CCTV cameras. Weather-resistant plastic housing for concealing cable connections and IP camera mounting on walls. Easy drill-and-mount installation."
    },
    {
      "id": "prod_189",
      "name": "CP Plus 4 Port Giga PoE Switch (CP-DNW-GPU4G2-48)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "CP Plus",
      "image": "/assets/images/nicedeal/fa1b6a_97ea90fa207044ae82ce1970ed4db5eb_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 234,
      "price": "₹2,600",
      "oldPrice": "₹3,400",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 76,
      "isDeal": false,
      "tags": ["PoE Switch", "Gigabit", "4 Port", "Compact"],
      "sku": "CP-DNW-GPU4G2-48",
      "description": "CP Plus 4-Port Gigabit PoE Switch with 48W PoE budget, 1000Mbps ports, IEEE 802.3af/at compliant, compact design for small CCTV or Wi-Fi AP deployments."
    },

    // — Hikvision IP CCTV —
    {
      "id": "prod_190",
      "name": "Hikvision 2MP ColorVu Fixed Dome Network Camera (DS-2CD2147G2-L)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.7",
      "reviewsCount": 432,
      "price": "₹4,500",
      "oldPrice": "₹5,800",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 87,
      "isDeal": true,
      "tags": ["IP Camera", "ColorVu", "Full-Time Color", "2MP", "Dome", "H.265+"],
      "sku": "DS-2CD2147G2-L",
      "description": "Hikvision 2MP ColorVu Full-Time Color Dome Camera with 4mm fixed lens, advanced color imaging in complete darkness using warm supplemental light, H.265+ codec, IP67 & IK10 rating, and PoE."
    },
    {
      "id": "prod_191",
      "name": "Hikvision 4MP AcuSense Fixed Dome Network Camera (DS-2CD2146G2-I)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.8",
      "reviewsCount": 356,
      "price": "₹5,800",
      "oldPrice": "₹7,500",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 63,
      "isDeal": false,
      "tags": ["IP Camera", "AcuSense", "4MP", "AI", "Dome", "H.265+"],
      "sku": "DS-2CD2146G2-I",
      "description": "Hikvision 4MP AcuSense AI Dome Camera with deep learning-based human/vehicle classification, 60m IR night vision, H.265+, IP67, IK10, PoE for smart perimeter protection."
    },
    {
      "id": "prod_192",
      "name": "Hikvision 4MP AcuSense Fixed Bullet Network Camera (DS-2CD2T47G2-L)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.7",
      "reviewsCount": 289,
      "price": "₹6,200",
      "oldPrice": "₹8,000",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 51,
      "isDeal": false,
      "tags": ["IP Camera", "AcuSense", "ColorVu", "4MP", "Bullet", "60m"],
      "sku": "DS-2CD2T47G2-L",
      "description": "Hikvision 4MP ColorVu AcuSense Bullet Camera with 60m warm light range, full-time color imaging, AI human/vehicle detection, H.265+, IP67, and PoE support."
    },
    {
      "id": "prod_193",
      "name": "Hikvision 8MP (4K) AcuSense Fixed Dome Camera (DS-2CD2183G2-I)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.9",
      "reviewsCount": 178,
      "price": "₹9,500",
      "oldPrice": "₹12,500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 34,
      "isDeal": false,
      "tags": ["IP Camera", "8MP", "4K", "AcuSense", "AI", "Dome"],
      "sku": "DS-2CD2183G2-I",
      "description": "Hikvision 8MP 4K Ultra HD AcuSense Dome Camera with deep learning AI detection, 60m IR night vision, H.265+, WDR 120dB, IP67, IK10, and PoE for premium surveillance."
    },

    // — Hikvision DVRs (Analog HD CCTV) —
    {
      "id": "prod_194",
      "name": "Hikvision 4 Channel 1080p AcuSense DVR (iDS-7204HTHI-M1/S)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/dvr.png",
      "rating": "4.5",
      "reviewsCount": 234,
      "price": "₹7,500",
      "oldPrice": "₹9,500",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 42,
      "isDeal": false,
      "tags": ["DVR", "4 Channel", "AcuSense", "AI", "Analog HD", "1080p"],
      "sku": "iDS-7204HTHI-M1/S",
      "description": "Hikvision 4-Channel AcuSense DVR with AI perimeter protection, human/vehicle target classification, 1 SATA bay, HDMI + VGA output, and mobile app access."
    },
    {
      "id": "prod_195",
      "name": "Hikvision 8 Channel 5MP AcuSense DVR (iDS-7208HUHI-M2/S)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/dvr.png",
      "rating": "4.6",
      "reviewsCount": 189,
      "price": "₹12,500",
      "oldPrice": "₹16,000",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 28,
      "isDeal": false,
      "tags": ["DVR", "8 Channel", "5MP", "AcuSense", "AI", "Analog HD"],
      "sku": "iDS-7208HUHI-M2/S",
      "description": "Hikvision 8-Channel 5MP AcuSense DVR with AI perimeter protection, 2 SATA bays, HDMI + VGA output, face detection, and advanced deep learning analytics for analog cameras."
    },
    {
      "id": "prod_196",
      "name": "Hikvision 16 Channel 8MP 4K DVR (iDS-7216HUHI-M2/S)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/dvr.png",
      "rating": "4.7",
      "reviewsCount": 134,
      "price": "₹18,500",
      "oldPrice": "₹24,000",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 16,
      "isDeal": true,
      "tags": ["DVR", "16 Channel", "8MP", "4K", "AcuSense", "AI"],
      "sku": "iDS-7216HUHI-M2/S",
      "description": "Hikvision 16-Channel 4K AcuSense DVR with AI smart analytics, 2 SATA bays, 4K HDMI output, human & vehicle detection, and H.265+ Pro compression for large analog camera deployments."
    },

    // — CP Plus Analog HD CCTV Cameras —
    {
      "id": "prod_197",
      "name": "CP Plus 2MP Full HD Turret Camera (CP-VAT-T13FL2S-V3)",
      "category": "Security Systems",
      "subcategory": "CCTV Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/ip-camera.png",
      "rating": "4.3",
      "reviewsCount": 487,
      "price": "₹1,250",
      "oldPrice": "₹1,700",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 234,
      "isDeal": false,
      "tags": ["Analog HD", "2MP", "Turret Camera", "IR", "IP66"],
      "sku": "CP-VAT-T13FL2S-V3",
      "description": "CP Plus 2MP Full HD Turret Dome Camera with 20m IR night vision, HDCVI/AHD/TVI/CVBS support, IP66 weatherproof, 3.6mm fixed lens for indoor/outdoor analog HD surveillance."
    },
    {
      "id": "prod_198",
      "name": "CP Plus 5MP HD Super Lite Bullet Camera (CP-USC-TA51L2C-MDS)",
      "category": "Security Systems",
      "subcategory": "CCTV Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.5",
      "reviewsCount": 312,
      "price": "₹2,100",
      "oldPrice": "₹2,800",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 167,
      "isDeal": false,
      "tags": ["Analog HD", "5MP", "Bullet Camera", "Night Color", "IP67"],
      "sku": "CP-USC-TA51L2C-MDS",
      "description": "CP Plus 5MP Full Color Night Vision Bullet Camera with dual-LED smart light technology, 40m IR/white light range, IP67 weatherproofing, and AHD/CVI/TVI/CVBS output."
    },
    {
      "id": "prod_199",
      "name": "Hikvision 2MP ColorVu Turret Camera (DS-2CE70DF3T-PFS)",
      "category": "Security Systems",
      "subcategory": "CCTV Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/ip-camera.png",
      "rating": "4.6",
      "reviewsCount": 356,
      "price": "₹2,800",
      "oldPrice": "₹3,600",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 143,
      "isDeal": false,
      "tags": ["Analog HD", "2MP", "ColorVu", "Full-Time Color", "Turret", "Built-in MIC"],
      "sku": "DS-2CE70DF3T-PFS",
      "description": "Hikvision 2MP ColorVu Turret Camera with built-in MIC, full-time color imaging in complete darkness, 40m white light range, H.265+, IP67 & IK10 for outdoor use."
    },
    {
      "id": "prod_200",
      "name": "Hikvision 5MP Pro Turbo HD Fixed Dome Camera (DS-2CE76H0T-ITMFS)",
      "category": "Security Systems",
      "subcategory": "CCTV Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.7",
      "reviewsCount": 234,
      "price": "₹3,200",
      "oldPrice": "₹4,200",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 97,
      "isDeal": false,
      "tags": ["Analog HD", "5MP", "Dome", "AcuSense", "Built-in MIC"],
      "sku": "DS-2CE76H0T-ITMFS",
      "description": "Hikvision 5MP Pro Turbo HD Dome Camera with built-in MIC, 60m smart IR night vision, AcuSense false alarm reduction, IP67 & IK10, supports HDCVI/AHD/TVI/CVBS."
    },

    // — VDP (Video Door Phone) —
    {
      "id": "prod_201",
      "name": "CP Plus 7 inch Full HD Wi-Fi Video Door Phone (CP-VDP-WP71H-SE)",
      "category": "Security Systems",
      "subcategory": "Video Door Phones",
      "brand": "CP Plus",
      "image": "/assets/images/video-door-phone.png",
      "rating": "4.5",
      "reviewsCount": 178,
      "price": "₹6,500",
      "oldPrice": "₹8,500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 38,
      "isDeal": false,
      "tags": ["Video Door Phone", "VDP", "7 inch", "Wi-Fi", "Full HD"],
      "sku": "CP-VDP-WP71H-SE",
      "description": "CP Plus 7-inch Full HD Wi-Fi Video Door Phone with touchscreen monitor, two-way audio, night vision outdoor camera, door unlock control, mobile app access, and motion detection."
    },
    {
      "id": "prod_202",
      "name": "Hikvision 2MP Video Door Bell with HD Camera (DS-KD6003-WIP)",
      "category": "Security Systems",
      "subcategory": "Video Door Phones",
      "brand": "Hikvision",
      "image": "/assets/images/ip-camera.png",
      "rating": "4.6",
      "reviewsCount": 213,
      "price": "₹5,800",
      "oldPrice": "₹7,500",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 45,
      "isDeal": false,
      "tags": ["Video Door Phone", "VDP", "2MP", "Wi-Fi", "IP65", "Smart Home"],
      "sku": "DS-KD6003-WIP",
      "description": "Hikvision 2MP Wi-Fi Video Door Bell with HD wide-angle camera, night vision, two-way audio, motion detection, mobile app integration, IP65 weatherproof, and 180° fisheye view."
    },
    {
      "id": "prod_203",
      "name": "Dahua 2MP HD Video Door Bell (VTO2202F-P)",
      "category": "Security Systems",
      "subcategory": "Video Door Phones",
      "brand": "Dahua",
      "image": "/assets/images/video-door-phone.png",
      "rating": "4.4",
      "reviewsCount": 156,
      "price": "₹4,950",
      "oldPrice": "₹6,500",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 29,
      "isDeal": false,
      "tags": ["Video Door Phone", "VDP", "2MP", "PoE", "IP65"],
      "sku": "VTO2202F-P",
      "description": "Dahua 2MP HD Video Door Bell with 2MP camera, two-way audio, IR night vision, IP65 weatherproof, PoE power, ONVIF compatibility, and standalone call function."
    },

    // — EPABX / Intercom Systems —
    {
      "id": "prod_204",
      "name": "Panasonic KX-NS300 Smart Hybrid PBX System (Basic Package)",
      "category": "Communication Systems",
      "subcategory": "EPABX Systems",
      "brand": "Panasonic",
      "image": "/assets/images/epabx.png",
      "rating": "4.5",
      "reviewsCount": 67,
      "price": "₹28,500",
      "oldPrice": "₹37,000",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 8,
      "isDeal": false,
      "tags": ["EPABX", "PBX", "IP PBX", "Intercom", "Office Telephone"],
      "sku": "KX-NS300",
      "description": "Panasonic KX-NS300 Smart Hybrid IP-PBX System for offices, supporting up to 288 extensions, SIP trunk, voicemail, call center features, unified communications, and DECT wireless phones."
    },
    {
      "id": "prod_205",
      "name": "Panasonic KX-TES824 EPABX System (3 Lines, 8 Extensions)",
      "category": "Communication Systems",
      "subcategory": "EPABX Systems",
      "brand": "Panasonic",
      "image": "/assets/images/epabx.png",
      "rating": "4.4",
      "reviewsCount": 134,
      "price": "₹8,500",
      "oldPrice": "₹11,000",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 22,
      "isDeal": false,
      "tags": ["EPABX", "PBX", "Small Business", "3 Lines", "8 Extensions"],
      "sku": "KX-TES824",
      "description": "Panasonic KX-TES824 EPABX for small businesses with 3 CO lines and 8 extensions. Features auto-attendant, call forwarding, hold, transfer, and intercom for offices up to 8 users."
    },

    // — Metal Detectors —
    {
      "id": "prod_206",
      "name": "WTMD Walk-Through Metal Detector (FMD-2000)",
      "category": "Security Systems",
      "subcategory": "Metal Detectors",
      "brand": "WTMD",
      "image": "/assets/images/metal-detector.png",
      "rating": "4.4",
      "reviewsCount": 89,
      "price": "₹45,000",
      "oldPrice": "₹58,000",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 6,
      "isDeal": false,
      "tags": ["Metal Detector", "Door Frame", "DFMD", "Security", "Walk-Through"],
      "sku": "FMD-2000",
      "description": "Walk-Through Door Frame Metal Detector with 18 independent detection zones, LCD display, adjustable sensitivity, 200 programmable threat programs, and high throughput for airports, malls, and offices."
    },
    {
      "id": "prod_207",
      "name": "Garrett Super Scanner V Handheld Metal Detector",
      "category": "Security Systems",
      "subcategory": "Metal Detectors",
      "brand": "Garrett",
      "image": "/assets/images/metal-detector.png",
      "rating": "4.7",
      "reviewsCount": 234,
      "price": "₹3,800",
      "oldPrice": "₹5,000",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 47,
      "isDeal": false,
      "tags": ["Metal Detector", "Handheld", "HHMD", "Security"],
      "sku": "Garrett-SuperV",
      "description": "Garrett Super Scanner V Handheld Metal Detector with 360° detection field, LED and tone alerts, water-resistant design, and high sensitivity for detecting knives, guns, and metallic objects."
    },

    // — Boom Barriers / Access Control —
    {
      "id": "prod_208",
      "name": "FAAC 615 BPR Boom Barrier (4m Arm, High Traffic)",
      "category": "Security Systems",
      "subcategory": "Access Control",
      "brand": "FAAC",
      "image": "/assets/images/boom-barrier.png",
      "rating": "4.6",
      "reviewsCount": 56,
      "price": "₹42,000",
      "oldPrice": "₹55,000",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 5,
      "isDeal": false,
      "tags": ["Boom Barrier", "Access Control", "Parking", "High Traffic", "FAAC"],
      "sku": "FAAC-615-BPR",
      "description": "FAAC 615 BPR Electromechanical Boom Barrier with 4m arm, high-traffic cycle duty (>600 cycles/hour), integrated LED lights, RS485 connectivity, and manual release for power failure."
    },
    {
      "id": "prod_209",
      "name": "Realtime RS9W Wi-Fi Biometric Attendance Machine with Access Control",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.5",
      "reviewsCount": 312,
      "price": "₹5,450",
      "oldPrice": "₹7,200",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 58,
      "isDeal": false,
      "tags": ["Biometric", "Wi-Fi", "Fingerprint", "Attendance", "Access Control", "Best Seller"],
      "sku": "Realtime-RS9W",
      "description": "Realtime RS9W Wi-Fi Fingerprint Biometric Attendance with built-in Wi-Fi for wireless cloud sync, 3,000 fingerprint capacity, door access control relay, and real-time attendance reporting."
    },
    {
      "id": "prod_210",
      "name": "CP Plus 4G SIM Card Wi-Fi Router (CP-XR-DN211-S)",
      "category": "IT & Networking",
      "subcategory": "WiFi Routers & Access Points",
      "brand": "CP Plus",
      "image": "/assets/images/router.png",
      "rating": "4.2",
      "reviewsCount": 189,
      "price": "₹2,150",
      "oldPrice": "₹2,800",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": ["Router", "4G", "SIM Card", "Wi-Fi", "CCTV"],
      "sku": "CP-XR-DN211-S",
      "description": "CP Plus 4G SIM Card Wi-Fi Router for wireless IP camera connectivity, supporting dual-band Wi-Fi, 4G LTE SIM, multiple device connectivity, and easy IP camera remote access setup."
    }
,
{
      "id": "prod_211",
      "name": "STQC | Honeywell IP 2MP Dome CCTV Camera | I-HIPD2PI-MF",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_03bb197839954b02a08aa55edac3b650_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 47,
      "price": "\u20b96,450",
      "oldPrice": "\u20b98,164",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 47,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "IP Cameras",
            "STQC Certified",
            "2MP"
      ],
      "sku": "I-HIPD2PI-MF",
      "description": "STQC | Honeywell IP 2MP Dome CCTV Camera | I-HIPD2PI-MF. High quality Honeywell IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_212",
      "name": "STQC | Honeywell IP 2MP Bullet CCTV Camera | I-HIPB2PI-MF",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_f4a648b3b27949ff865f2e3a6740cbc8_mv2.jpg",
      "rating": "4.7",
      "reviewsCount": 79,
      "price": "\u20b96,450",
      "oldPrice": "\u20b97,865",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 66,
      "isDeal": true,
      "tags": [
            "Honeywell",
            "IP Cameras",
            "STQC Certified",
            "2MP"
      ],
      "sku": "I-HIPB2PI-MF",
      "description": "STQC | Honeywell IP 2MP Bullet CCTV Camera | I-HIPB2PI-MF. High quality Honeywell IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_213",
      "name": "STQC | Honeywell IP 5MP Dome CCTV Camera | I-HIPD5PI-MF",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_03bb197839954b02a08aa55edac3b650_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 48,
      "price": "\u20b98,950",
      "oldPrice": "\u20b911,329",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 83,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "IP Cameras",
            "STQC Certified",
            "5MP"
      ],
      "sku": "I-HIPD5PI-MF",
      "description": "STQC | Honeywell IP 5MP Dome CCTV Camera | I-HIPD5PI-MF. High quality Honeywell IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_214",
      "name": "STQC | Honeywell IP 5MP Bullet CCTV Camera | I-HIPB5PI-MF",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_f4a648b3b27949ff865f2e3a6740cbc8_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 249,
      "price": "\u20b98,750",
      "oldPrice": "\u20b911,666",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 40,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "IP Cameras",
            "STQC Certified",
            "5MP"
      ],
      "sku": "I-HIPB5PI-MF",
      "description": "STQC | Honeywell IP 5MP Bullet CCTV Camera | I-HIPB5PI-MF. High quality Honeywell IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_215",
      "name": "STQC | Honeywell IP 5MP VariFocal Dome CCTV Camera | I-HIPD5PI-MV",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_81256a8aac384539a9be0365f8e25d79_mv2.jpg",
      "rating": "4.7",
      "reviewsCount": 38,
      "price": "\u20b914,450",
      "oldPrice": "\u20b919,013",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 32,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "IP Cameras",
            "STQC Certified",
            "5MP"
      ],
      "sku": "I-HIPD5PI-MV",
      "description": "STQC | Honeywell IP 5MP VariFocal Dome CCTV Camera | I-HIPD5PI-MV. High quality Honeywell IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_216",
      "name": "STQC | Honeywell IP 5MP VariFocal Bullet CCTV Camera | I-HIPB5PI-MV",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_1fc6a555679b4f09996cab610a151e92_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 207,
      "price": "\u20b913,750",
      "oldPrice": "\u20b916,975",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 25,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "IP Cameras",
            "STQC Certified",
            "5MP"
      ],
      "sku": "I-HIPB5PI-MV",
      "description": "STQC | Honeywell IP 5MP VariFocal Bullet CCTV Camera | I-HIPB5PI-MV. High quality Honeywell IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_217",
      "name": "STQC | Honeywell IP 5MP ANPR Bullet CCTV Camera | I-HIPB5PI-LPD",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_a29f93243aaf4b40b5e314cb186d2ce4_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 211,
      "price": "\u20b934,500",
      "oldPrice": "\u20b944,230",
      "discount": "22% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "IP Cameras",
            "STQC Certified",
            "5MP"
      ],
      "sku": "I-HIPB5PI-LPD",
      "description": "STQC | Honeywell IP 5MP ANPR Bullet CCTV Camera | I-HIPB5PI-LPD. High quality Honeywell IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_218",
      "name": "STQC | Honeywell IP 2MP 25x 150m PTZ CCTV Camera | I-HIP2PI-P25X",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_42900ff868844d06bc00310fc8c11231_mv2.jpg",
      "rating": "4.7",
      "reviewsCount": 98,
      "price": "\u20b939,500",
      "oldPrice": "\u20b951,973",
      "discount": "24% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": true,
      "tags": [
            "Honeywell",
            "IP Cameras",
            "STQC Certified",
            "2MP"
      ],
      "sku": "I-HIP2PI-P25X",
      "description": "STQC | Honeywell IP 2MP 25x 150m PTZ CCTV Camera | I-HIP2PI-P25X. High quality Honeywell IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_219",
      "name": "Honeywell 5 Channel 4K NVR | I-HNVR-1105",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_f0301f00985a4c50916ed918932add70_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 220,
      "price": "\u20b95,950",
      "oldPrice": "\u20b97,531",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 85,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "I-HNVR-1105",
      "description": "Honeywell 5 Channel 4K NVR | I-HNVR-1105. High quality Honeywell CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_220",
      "name": "Honeywell 20 Channel 2-SATA 4K NVR | I-HNVR-1220",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_f0301f00985a4c50916ed918932add70_mv2.jpg",
      "rating": "4.0",
      "reviewsCount": 151,
      "price": "\u20b917,250",
      "oldPrice": "\u20b921,296",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 49,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "I-HNVR-1220",
      "description": "Honeywell 20 Channel 2-SATA 4K NVR | I-HNVR-1220. High quality Honeywell CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_221",
      "name": "Honeywell 40 Channel 2-SATA 4K NVR | I-HNVR-1240",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_f0301f00985a4c50916ed918932add70_mv2.jpg",
      "rating": "4.8",
      "reviewsCount": 229,
      "price": "\u20b921,950",
      "oldPrice": "\u20b929,266",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 47,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "I-HNVR-1240",
      "description": "Honeywell 40 Channel 2-SATA 4K NVR | I-HNVR-1240. High quality Honeywell CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_222",
      "name": "Honeywell 16 Channel 4-SATA 4K NVR | I-HPNVR-416",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_8a9cc12cf0bf4a0586cc48e2fab4804b_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 224,
      "price": "\u20b921,450",
      "oldPrice": "\u20b927,857",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "CCTV Accessories",
            "4K"
      ],
      "sku": " I-HPNVR-416",
      "description": "Honeywell 16 Channel 4-SATA 4K NVR | I-HPNVR-416. High quality Honeywell CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_223",
      "name": "Honeywell 32 Channel 4-SATA 4K NVR | I-HPNVR-432",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_8a9cc12cf0bf4a0586cc48e2fab4804b_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 71,
      "price": "\u20b929,450",
      "oldPrice": "\u20b939,797",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 33,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "I-HPNVR-432",
      "description": "Honeywell 32 Channel 4-SATA 4K NVR | I-HPNVR-432. High quality Honeywell CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_224",
      "name": "Honeywell 64 Channel 8-SATA 4K NVR | I-HPNVR-864",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_8a9cc12cf0bf4a0586cc48e2fab4804b_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 229,
      "price": "\u20b974,500",
      "oldPrice": "\u20b9100,675",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 46,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "I-HPNVR-864",
      "description": "Honeywell 64 Channel 8-SATA 4K NVR | I-HPNVR-864. High quality Honeywell CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_225",
      "name": "Honeywell 64 Channel 16-SATA 4K NVR | I-HPNVR-1664",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Honeywell",
      "image": "/assets/images/nicedeal/fa1b6a_148c2db731604b3f9bd108247a9e7968_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 63,
      "price": "\u20b9129,500",
      "oldPrice": "\u20b9157,926",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 41,
      "isDeal": false,
      "tags": [
            "Honeywell",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "I-HPNVR-1664",
      "description": "Honeywell 64 Channel 16-SATA 4K NVR | I-HPNVR-1664. High quality Honeywell CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_226",
      "name": "NETGEAR 8-Port Giga PoE+ Switch | GS108LP",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Netgear",
      "image": "/assets/images/nicedeal/fa1b6a_62b5a1b6940e41b390f88d1f9a07a581_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 68,
      "price": "\u20b97,950",
      "oldPrice": "\u20b910,324",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 39,
      "isDeal": false,
      "tags": [
            "Netgear",
            "Network Switches",
            "PoE"
      ],
      "sku": "GS108LP",
      "description": "NETGEAR 8-Port Giga PoE+ Switch | GS108LP. High quality Netgear Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_227",
      "name": "NETGEAR 16-Port Giga PoE+ Switch | GS116LP",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Netgear",
      "image": "/assets/images/nicedeal/fa1b6a_2b4936b3701e477a8ab29e0bdd45ded8_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 269,
      "price": "\u20b914,450",
      "oldPrice": "\u20b918,525",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 30,
      "isDeal": true,
      "tags": [
            "Netgear",
            "Network Switches",
            "PoE"
      ],
      "sku": "GS116LP",
      "description": "NETGEAR 16-Port Giga PoE+ Switch | GS116LP. High quality Netgear Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_228",
      "name": "NETGEAR 24-Port Giga PoE+ Smart Managed Switch | GS724TP",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Netgear",
      "image": "/assets/images/nicedeal/fa1b6a_144c9a2675064b75b27cfc18af8f6834_mv2.jpg",
      "rating": "4.7",
      "reviewsCount": 169,
      "price": "\u20b932,500",
      "oldPrice": "\u20b942,763",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 66,
      "isDeal": false,
      "tags": [
            "Netgear",
            "Network Switches",
            "PoE"
      ],
      "sku": "GS724TP",
      "description": "NETGEAR 24-Port Giga PoE+ Smart Managed Switch | GS724TP. High quality Netgear Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_229",
      "name": "NETGEAR 48-Port Giga PoE+ Smart Managed Switch | GS752TP",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Netgear",
      "image": "/assets/images/nicedeal/fa1b6a_3246fa906b2a461db35bae35ba7284fc_mv2.jpg",
      "rating": "4.9",
      "reviewsCount": 105,
      "price": "\u20b979,500",
      "oldPrice": "\u20b9106,000",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 77,
      "isDeal": true,
      "tags": [
            "Netgear",
            "Network Switches",
            "PoE"
      ],
      "sku": "GS752TP",
      "description": "NETGEAR 48-Port Giga PoE+ Smart Managed Switch | GS752TP. High quality Netgear Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_230",
      "name": "D-Link Premium RJ-45 Connector",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "D-Link",
      "image": "/assets/images/nicedeal/fa1b6a_7d4d469dea5141f0b4d0a4fe66adff89_mv2.jpg",
      "rating": "4.0",
      "reviewsCount": 91,
      "price": "\u20b95",
      "oldPrice": "\u20b96",
      "discount": "20% OFF",
      "inStock": true,
      "stockQuantity": 31,
      "isDeal": false,
      "tags": [
            "D-Link",
            "Cables & Connectors"
      ],
      "sku": "DLink-RJ45-Loose",
      "description": "D-Link Premium RJ-45 Connector. High quality D-Link Cables & Connectors designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_231",
      "name": "PVC Junction Box (5\"x5\") for CCTV",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_7167752bb4844745b498cbe176f4a4bb_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 67,
      "price": "\u20b945",
      "oldPrice": "\u20b959",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 61,
      "isDeal": false,
      "tags": [
            "Unknown",
            "CCTV Accessories"
      ],
      "sku": "PVC Box Indoor",
      "description": "PVC Junction Box (5\"x5\") for CCTV. High quality Unknown CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_232",
      "name": "Outdoor PVC Junction Box (5\"x5\") for CCTV",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_6cdcd42457a94c31ba40023e27df4339_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 163,
      "price": "\u20b995",
      "oldPrice": "\u20b9115",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 82,
      "isDeal": false,
      "tags": [
            "Unknown",
            "CCTV Accessories"
      ],
      "sku": "Junction Box OD",
      "description": "Outdoor PVC Junction Box (5\"x5\") for CCTV. High quality Unknown CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_233",
      "name": "CCTV Wall Mount Camera Stand (10\" Metal)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_1d841c0a32e94d5a99a7db31a192dea5_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 171,
      "price": "\u20b9195",
      "oldPrice": "\u20b9240",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 55,
      "isDeal": false,
      "tags": [
            "Unknown",
            "CCTV Accessories"
      ],
      "sku": "Wall Mount Stand",
      "description": "CCTV Wall Mount Camera Stand (10\" Metal). High quality Unknown CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_234",
      "name": "CCTV Pole Mount Stand Camera with Clamp (Metal)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_2441065fbe3d496a8e8ad72bd3843ad6_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 36,
      "price": "\u20b9195",
      "oldPrice": "\u20b9263",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 45,
      "isDeal": false,
      "tags": [
            "Unknown",
            "CCTV Accessories"
      ],
      "sku": "Pole Mount Stand",
      "description": "CCTV Pole Mount Stand Camera with Clamp (Metal). High quality Unknown CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_235",
      "name": "Heavy-Duty CCTV Camera Cage | Wall Mount Metal for Outdoor",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_4c5f01e087be4dfdb4d98eedc4d2a839_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 89,
      "price": "\u20b9250",
      "oldPrice": "\u20b9337",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 50,
      "isDeal": false,
      "tags": [
            "Unknown",
            "CCTV Accessories"
      ],
      "sku": "CCTV Cage (Heavy)",
      "description": "Heavy-Duty CCTV Camera Cage | Wall Mount Metal for Outdoor. High quality Unknown CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_236",
      "name": "PVC Rack for Mini DVR and PoE Switch (Indoor / Outdoor)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_7e4766817e3c49b3bdc9964eb0fba4b6_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 117,
      "price": "\u20b9495",
      "oldPrice": "\u20b9668",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 81,
      "isDeal": false,
      "tags": [
            "Unknown",
            "CCTV Accessories",
            "PoE"
      ],
      "sku": "PVC-2URack",
      "description": "PVC Rack for Mini DVR and PoE Switch (Indoor / Outdoor). High quality Unknown CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_237",
      "name": "Prama PT-CLN6-P/G CAT6 Copper UTP Network Cable \u2013 305 Meter",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_3f1bd65cd1fc41899fbd5450bf66f2e3_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 285,
      "price": "\u20b911,500",
      "oldPrice": "\u20b914,197",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 14,
      "isDeal": false,
      "tags": [
            "Prama",
            "Cables & Connectors"
      ],
      "sku": "PT-CLN6-P/G",
      "description": "Prama PT-CLN6-P/G CAT6 Copper UTP Network Cable \u2013 305 Meter. High quality Prama Cables & Connectors designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_238",
      "name": "D-Link CAT6 UTP Pure Copper 305mtrs Cable",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "D-Link",
      "image": "/assets/images/nicedeal/fa1b6a_6d28433add8648b1880deb5b59fde3dc_mv2.jpg",
      "rating": "4.8",
      "reviewsCount": 192,
      "price": "\u20b911,950",
      "oldPrice": "\u20b914,573",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 42,
      "isDeal": false,
      "tags": [
            "D-Link",
            "Cables & Connectors"
      ],
      "sku": "NCB-C6UGRYR-305",
      "description": "D-Link CAT6 UTP Pure Copper 305mtrs Cable. High quality D-Link Cables & Connectors designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_239",
      "name": "D-Link CAT6 Armoured UTP Pure Copper Cable (305 Meters) \u2013 Black",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "D-Link",
      "image": "/assets/images/nicedeal/fa1b6a_1993a97abb824182bdbc3bcafb05a7e5_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 75,
      "price": "\u20b923,950",
      "oldPrice": "\u20b931,933",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 22,
      "isDeal": false,
      "tags": [
            "D-Link",
            "Cables & Connectors"
      ],
      "sku": "D-Link Armoured 305",
      "description": "D-Link CAT6 Armoured UTP Pure Copper Cable (305 Meters) \u2013 Black. High quality D-Link Cables & Connectors designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_240",
      "name": "WD Purple 2TB SATA Surveillance Hard Drive",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Western Digital",
      "image": "/assets/images/nicedeal/fa1b6a_72d2d9eecc84465387e4f205255013e5_mv2.jpg",
      "rating": "4.9",
      "reviewsCount": 99,
      "price": "\u20b913,450",
      "oldPrice": "\u20b917,933",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 28,
      "isDeal": false,
      "tags": [
            "Western Digital",
            "IP Cameras"
      ],
      "sku": "WD Purple 2TB",
      "description": "WD Purple 2TB SATA Surveillance Hard Drive. High quality Western Digital IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_241",
      "name": "WD Purple 4TB SATA Surveillance Hard Drive",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Western Digital",
      "image": "/assets/images/nicedeal/fa1b6a_fc5e96201764486fad2834c42d11654b_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 251,
      "price": "\u20b917,750",
      "oldPrice": "\u20b923,986",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 39,
      "isDeal": false,
      "tags": [
            "Western Digital",
            "IP Cameras"
      ],
      "sku": "WD Purple 4TB",
      "description": "WD Purple 4TB SATA Surveillance Hard Drive. High quality Western Digital IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_242",
      "name": "WD Purple 6TB SATA Surveillance Hard Drive",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Western Digital",
      "image": "/assets/images/nicedeal/fa1b6a_3ffc98557a9c42b5aa4976eac296ced5_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 194,
      "price": "\u20b925,960",
      "oldPrice": "\u20b933,714",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 63,
      "isDeal": false,
      "tags": [
            "Western Digital",
            "IP Cameras"
      ],
      "sku": "WD Purple 6TB",
      "description": "WD Purple 6TB SATA Surveillance Hard Drive. High quality Western Digital IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_243",
      "name": "WD Purple Pro 8TB SATA Surveillance Hard Drive | HDD",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Western Digital",
      "image": "/assets/images/nicedeal/fa1b6a_ce52dccf6d8442f08fe890b8c9679702_mv2.png",
      "rating": "4.5",
      "reviewsCount": 96,
      "price": "\u20b941,450",
      "oldPrice": "\u20b952,468",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 43,
      "isDeal": true,
      "tags": [
            "Western Digital",
            "IP Cameras"
      ],
      "sku": "WD Purple 8TB",
      "description": "WD Purple Pro 8TB SATA Surveillance Hard Drive | HDD. High quality Western Digital IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_244",
      "name": "WD Purple Pro 10TB SATA Surveillance HDD Hard Drive",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Western Digital",
      "image": "/assets/images/nicedeal/fa1b6a_b28a0a6831164f6fbc6383fbe0d8f4a2_mv2.jpg",
      "rating": "4.0",
      "reviewsCount": 152,
      "price": "\u20b954,500",
      "oldPrice": "\u20b966,463",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 40,
      "isDeal": true,
      "tags": [
            "Western Digital",
            "IP Cameras"
      ],
      "sku": "WDPurple10TB",
      "description": "WD Purple Pro 10TB SATA Surveillance HDD Hard Drive. High quality Western Digital IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_245",
      "name": "STQC | Prama 2MP IP Dome Network CCTV Camera | PT-NC123D3-N(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_0412cb9cdc0e44b3840de35f6612b85b_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 152,
      "price": "\u20b93,150",
      "oldPrice": "\u20b93,841",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 20,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified",
            "2MP"
      ],
      "sku": "PT-NC123D3-N(D2)",
      "description": "STQC | Prama 2MP IP Dome Network CCTV Camera | PT-NC123D3-N(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_246",
      "name": "STQC | Prama 2MP IP Bullet Network CCTV Camera | PT-NC120D3-N(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_deb1112710fc402e84632bcaa0ac87a7_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 156,
      "price": "\u20b93,200",
      "oldPrice": "\u20b94,266",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 47,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified",
            "2MP"
      ],
      "sku": "PT-NC120D3-N(D2)",
      "description": "STQC | Prama 2MP IP Bullet Network CCTV Camera | PT-NC120D3-N(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_247",
      "name": "STQC | Prama IP 2MP Hybrid Dome CCTV with MIC | PT-NC123D3-WNM(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_2db87af0ecce4677813710ecc4268104_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 277,
      "price": "\u20b93,350",
      "oldPrice": "\u20b94,466",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 43,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified",
            "2MP"
      ],
      "sku": "PT-NC123D3-WNM(D2)",
      "description": "STQC | Prama IP 2MP Hybrid Dome CCTV with MIC | PT-NC123D3-WNM(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_248",
      "name": "STQC | Prama IP 2MP Hybrid Bullet CCTV with MIC | PT-NC120D3-WNM(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_7584af6afb814bc996031f50a48caae3_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 84,
      "price": "\u20b93,400",
      "oldPrice": "\u20b94,415",
      "discount": "23% OFF",
      "inStock": true,
      "stockQuantity": 67,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified",
            "2MP"
      ],
      "sku": "PT-NC120D3-WNM(D2)",
      "description": "STQC | Prama IP 2MP Hybrid Bullet CCTV with MIC | PT-NC120D3-WNM(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_249",
      "name": "STQC | Prama 4MP IP Dome Network CCTV Camera | PT-NC143D3-N(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_0412cb9cdc0e44b3840de35f6612b85b_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 62,
      "price": "\u20b93,950",
      "oldPrice": "\u20b94,817",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 24,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified"
      ],
      "sku": "PT-NC143D3-N(D2)",
      "description": "STQC | Prama 4MP IP Dome Network CCTV Camera | PT-NC143D3-N(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_250",
      "name": "STQC | Prama 4MP IP Bullet Network CCTV Camera | PT-NC140D3-N(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_deb1112710fc402e84632bcaa0ac87a7_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 90,
      "price": "\u20b94,000",
      "oldPrice": "\u20b95,063",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 43,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified"
      ],
      "sku": "PT-NC140D3-N(D2)",
      "description": "STQC | Prama 4MP IP Bullet Network CCTV Camera | PT-NC140D3-N(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_251",
      "name": "STQC | Prama IP 4MP Hybrid Dome CCTV with MIC | PT-NC143D3-WNM(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_2db87af0ecce4677813710ecc4268104_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 251,
      "price": "\u20b94,150",
      "oldPrice": "\u20b95,320",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 35,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified"
      ],
      "sku": "PT-NC143D3-WNM(D2)",
      "description": "STQC | Prama IP 4MP Hybrid Dome CCTV with MIC | PT-NC143D3-WNM(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_252",
      "name": "STQC | Prama IP 4MP Hybrid Bullet CCTV with MIC | PT-NC140D3-WNM(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_7584af6afb814bc996031f50a48caae3_mv2.jpg",
      "rating": "4.8",
      "reviewsCount": 73,
      "price": "\u20b94,200",
      "oldPrice": "\u20b95,675",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 68,
      "isDeal": true,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified"
      ],
      "sku": "PT-NC140D3-WNM(D2)",
      "description": "STQC | Prama IP 4MP Hybrid Bullet CCTV with MIC | PT-NC140D3-WNM(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_253",
      "name": "STQC | Prama IP 6MP Hybrid Dome CCTV with MIC | PT-NC163D3-WNM(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_2db87af0ecce4677813710ecc4268104_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 42,
      "price": "\u20b95,950",
      "oldPrice": "\u20b97,531",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 23,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified"
      ],
      "sku": "PT-NC163D3-WNM(D2)",
      "description": "STQC | Prama IP 6MP Hybrid Dome CCTV with MIC | PT-NC163D3-WNM(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_254",
      "name": "STQC | Prama IP 6MP Hybrid Bullet CCTV with MIC | PT-NC160D3-WNM(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_7584af6afb814bc996031f50a48caae3_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 144,
      "price": "\u20b96,000",
      "oldPrice": "\u20b97,894",
      "discount": "24% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified"
      ],
      "sku": "PT-NC160D3-WNM(D2)",
      "description": "STQC | Prama IP 6MP Hybrid Bullet CCTV with MIC | PT-NC160D3-WNM(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_255",
      "name": "STQC | Prama IP 4MP Hybrid Varifocal Dome CCTV | PT-NC147D3-WNRAM(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_d82c8bfe2cf5444db64fbccabe5174b2_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 36,
      "price": "\u20b911,250",
      "oldPrice": "\u20b914,423",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 61,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified"
      ],
      "sku": "PT-NC147D3-WNRAM (D2)",
      "description": "STQC | Prama IP 4MP Hybrid Varifocal Dome CCTV | PT-NC147D3-WNRAM(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_256",
      "name": "STQC | Prama IP 4MP Hybrid Varifocal Bullet CCTV | PT-NC146D3-WNRAM(D2)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_b4c82ef0894d49788b8753eb43f42118_mv2.jpg",
      "rating": "4.7",
      "reviewsCount": 181,
      "price": "\u20b911,250",
      "oldPrice": "\u20b915,202",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 66,
      "isDeal": false,
      "tags": [
            "Prama",
            "IP Cameras",
            "STQC Certified"
      ],
      "sku": "PT-NC146D3-WNRAM(D2)",
      "description": "STQC | Prama IP 4MP Hybrid Varifocal Bullet CCTV | PT-NC146D3-WNRAM(D2). High quality Prama IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_257",
      "name": "Prama 4 Channel NVR | PT-NR1A04-Q1",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_5eb6d64368274675989c552199484d87_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 132,
      "price": "\u20b93,950",
      "oldPrice": "\u20b95,000",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 49,
      "isDeal": false,
      "tags": [
            "Prama",
            "CCTV Accessories"
      ],
      "sku": "PT-NR1A04-Q1",
      "description": "Prama 4 Channel NVR | PT-NR1A04-Q1. High quality Prama CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_258",
      "name": "Prama 8 Channel NVR | PT-NR1A08-Q1",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_5eb6d64368274675989c552199484d87_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 66,
      "price": "\u20b94,750",
      "oldPrice": "\u20b95,792",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 52,
      "isDeal": true,
      "tags": [
            "Prama",
            "CCTV Accessories"
      ],
      "sku": "PT-NR1A08-Q1",
      "description": "Prama 8 Channel NVR | PT-NR1A08-Q1. High quality Prama CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_259",
      "name": "Prama 4K 8 Channel NVR | PT-NR2A08-Q1",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_5eb6d64368274675989c552199484d87_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 115,
      "price": "\u20b96,250",
      "oldPrice": "\u20b98,445",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 19,
      "isDeal": true,
      "tags": [
            "Prama",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "PT-NR2A08-Q1",
      "description": "Prama 4K 8 Channel NVR | PT-NR2A08-Q1. High quality Prama CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_260",
      "name": "Prama 4K 16 Channel NVR | PT-NR2A16-Q1",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_5eb6d64368274675989c552199484d87_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 69,
      "price": "\u20b913,600",
      "oldPrice": "\u20b917,894",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 42,
      "isDeal": true,
      "tags": [
            "Prama",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "PT-NR2A16-Q1",
      "description": "Prama 4K 16 Channel NVR | PT-NR2A16-Q1. High quality Prama CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_261",
      "name": "Prama 4K 16 Channel 2 SATA NVR | PT-NRAS2A16-K2",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_5eb6d64368274675989c552199484d87_mv2.jpg",
      "rating": "4.8",
      "reviewsCount": 161,
      "price": "\u20b911,950",
      "oldPrice": "\u20b914,753",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 17,
      "isDeal": false,
      "tags": [
            "Prama",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "PT-NRAS2A16-K2",
      "description": "Prama 4K 16 Channel 2 SATA NVR | PT-NRAS2A16-K2. High quality Prama CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_262",
      "name": "Prama 4K 32 Channel 2 SATA NVR | PT-NRAS2A32-K2",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_5eb6d64368274675989c552199484d87_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 196,
      "price": "\u20b914,750",
      "oldPrice": "\u20b918,670",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 45,
      "isDeal": false,
      "tags": [
            "Prama",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "PT-NRAS2A32-K2",
      "description": "Prama 4K 32 Channel 2 SATA NVR | PT-NRAS2A32-K2. High quality Prama CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_263",
      "name": "Prama 4K 32 Channel 4-SATA NVR | PT-NRAS2B32-K4",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_5eb6d64368274675989c552199484d87_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 170,
      "price": "\u20b924,950",
      "oldPrice": "\u20b932,828",
      "discount": "24% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": true,
      "tags": [
            "Prama",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "PT-NRAS2B32-K4",
      "description": "Prama 4K 32 Channel 4-SATA NVR | PT-NRAS2B32-K4. High quality Prama CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_264",
      "name": "Prama Pro 4K 64 Channel 4-SATA NVR | PT-NR2B64-K4",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Prama",
      "image": "/assets/images/nicedeal/fa1b6a_5eb6d64368274675989c552199484d87_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 269,
      "price": "\u20b934,500",
      "oldPrice": "\u20b942,592",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 52,
      "isDeal": true,
      "tags": [
            "Prama",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "PT-NR2B64-K4",
      "description": "Prama Pro 4K 64 Channel 4-SATA NVR | PT-NR2B64-K4. High quality Prama CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_265",
      "name": "CP Plus 8 Port Giga PoE Switch with SFP Port (CP-DNW-GPU8G2F2-96)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "CP Plus",
      "image": "/assets/images/nicedeal/fa1b6a_b6e0c031df3e4ef59eddc8426aef2116_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 86,
      "price": "\u20b94,450",
      "oldPrice": "\u20b96,013",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 21,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "Network Switches",
            "PoE"
      ],
      "sku": "CP-DNW-GPU8G2F2-96",
      "description": "CP Plus 8 Port Giga PoE Switch with SFP Port (CP-DNW-GPU8G2F2-96). High quality CP Plus Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_266",
      "name": "D-Link 8-Port Giga PoE+ Switch (DGS-F1010P-E)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "D-Link",
      "image": "/assets/images/nicedeal/fa1b6a_4dc07f88d2f545eba5e72c321f1e5a16_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 213,
      "price": "\u20b96,950",
      "oldPrice": "\u20b98,797",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 20,
      "isDeal": false,
      "tags": [
            "D-Link",
            "Network Switches",
            "PoE"
      ],
      "sku": "DGS-F1010P-E",
      "description": "D-Link 8-Port Giga PoE+ Switch (DGS-F1010P-E). High quality D-Link Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_267",
      "name": "D-Link 16-Port Giga PoE+ Switch (DGS-F1018P-E)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "D-Link",
      "image": "/assets/images/nicedeal/fa1b6a_a5a8b3840b494f34a265d974950145a2_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 189,
      "price": "\u20b911,450",
      "oldPrice": "\u20b913,963",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 79,
      "isDeal": false,
      "tags": [
            "D-Link",
            "Network Switches",
            "PoE"
      ],
      "sku": "DGS-F1018P-E",
      "description": "D-Link 16-Port Giga PoE+ Switch (DGS-F1018P-E). High quality D-Link Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_268",
      "name": "D-Link 24-Port Giga PoE+ Managed Switch (DGS-1210-28P)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "D-Link",
      "image": "/assets/images/nicedeal/fa1b6a_36d094f643af42629ef8c1b92da317cf_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 88,
      "price": "\u20b926,450",
      "oldPrice": "\u20b933,910",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 29,
      "isDeal": true,
      "tags": [
            "D-Link",
            "Network Switches",
            "PoE"
      ],
      "sku": "DGS-1210-28P",
      "description": "D-Link 24-Port Giga PoE+ Managed Switch (DGS-1210-28P). High quality D-Link Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_269",
      "name": "Metal Folding 2U Wall Mount Rack with Lock",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_cf9f3e48d7864ea0808a65e35c099672_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 114,
      "price": "\u20b9650",
      "oldPrice": "\u20b9833",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 46,
      "isDeal": false,
      "tags": [
            "Unknown",
            "CCTV Accessories"
      ],
      "sku": "2U Metal Rack",
      "description": "Metal Folding 2U Wall Mount Rack with Lock. High quality Unknown CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_270",
      "name": "Metal Folding 4U Wall Mount Rack with Lock",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_cf9f3e48d7864ea0808a65e35c099672_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 139,
      "price": "\u20b9950",
      "oldPrice": "\u20b91,283",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 45,
      "isDeal": false,
      "tags": [
            "Unknown",
            "CCTV Accessories"
      ],
      "sku": "4U Metal Rack",
      "description": "Metal Folding 4U Wall Mount Rack with Lock. High quality Unknown CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_271",
      "name": "Unitech IP 4MP Night Color with MIC Dome Camera | UTIPDCP-5101",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_b1927aee18044a1ca6e3c81b3303da3a_mv2.jpg",
      "rating": "4.8",
      "reviewsCount": 61,
      "price": "\u20b92,350",
      "oldPrice": "\u20b93,092",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 23,
      "isDeal": false,
      "tags": [
            "Unknown",
            "IP Cameras"
      ],
      "sku": "UTIPDCPC-5210",
      "description": "Unitech IP 4MP Night Color with MIC Dome Camera | UTIPDCP-5101. High quality Unknown IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_272",
      "name": "Unitech IP 4MP Night Color with MIC Bullet Camera | UTIPBCP-5101",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Generic",
      "image": "/assets/images/nicedeal/fa1b6a_e4edf5bc24ee4ccca3b78fc4a6cb3990_mv2.jpg",
      "rating": "4.0",
      "reviewsCount": 205,
      "price": "\u20b92,350",
      "oldPrice": "\u20b93,012",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 28,
      "isDeal": false,
      "tags": [
            "Unknown",
            "IP Cameras"
      ],
      "sku": "UTIPBCP-5101",
      "description": "Unitech IP 4MP Night Color with MIC Bullet Camera | UTIPBCP-5101. High quality Unknown IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_273",
      "name": "HIKVISION IP 2MP Dome H.265+ Network CCTV (DS-2CD1323G0E-I)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_ddee803b21354a868b7890455c3f616a_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 253,
      "price": "\u20b93,250",
      "oldPrice": "\u20b94,391",
      "discount": "26% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": true,
      "tags": [
            "Hikvision",
            "IP Cameras",
            "2MP"
      ],
      "sku": " DS-2CD1323G0E-I",
      "description": "HIKVISION IP 2MP Dome H.265+ Network CCTV (DS-2CD1323G0E-I). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_274",
      "name": "HIKVISION IP 2MP Bullet H.265+ Network CCTV (DS-2CD1023G0E-I)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_7a6ea5f3a24f4c8cb6746a23939159ca_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 111,
      "price": "\u20b93,300",
      "oldPrice": "\u20b94,459",
      "discount": "26% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": true,
      "tags": [
            "Hikvision",
            "IP Cameras",
            "2MP"
      ],
      "sku": "DS-2CD1023G0E-I",
      "description": "HIKVISION IP 2MP Bullet H.265+ Network CCTV (DS-2CD1023G0E-I). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_275",
      "name": "HIKVISION IP 2MP Dome Smart Hybrid Light with MIC CCTV (DS-2CD1323G2-LIU)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_28fa0630028f45558711bfd56130c01c_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 110,
      "price": "\u20b94,250",
      "oldPrice": "\u20b95,592",
      "discount": "24% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": true,
      "tags": [
            "Hikvision",
            "IP Cameras",
            "2MP"
      ],
      "sku": "DS-2CD1323G2-LIU",
      "description": "HIKVISION IP 2MP Dome Smart Hybrid Light with MIC CCTV (DS-2CD1323G2-LIU). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_276",
      "name": "HIKVISION IP 2MP Bullet Smart Hybrid Light with MIC CCTV (DS-2CD1023G2-LIU)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_f112b48de710490691b917493c9082af_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 55,
      "price": "\u20b94,250",
      "oldPrice": "\u20b95,519",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras",
            "2MP"
      ],
      "sku": "DS-2CD1023G2-LIU",
      "description": "HIKVISION IP 2MP Bullet Smart Hybrid Light with MIC CCTV (DS-2CD1023G2-LIU). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_277",
      "name": "HIKVISION IP 4MP Dome Network H.265+ CCTV (DS-2CD1341G0-I)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_ddee803b21354a868b7890455c3f616a_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 87,
      "price": "\u20b94,450",
      "oldPrice": "\u20b95,779",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras"
      ],
      "sku": "DS-2CD1341G0-I",
      "description": "HIKVISION IP 4MP Dome Network H.265+ CCTV (DS-2CD1341G0-I). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_278",
      "name": "HIKVISION IP 4MP Bullet H.265+ Network CCTV | DS-2CD1043G0-IUF",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_7a6ea5f3a24f4c8cb6746a23939159ca_mv2.jpg",
      "rating": "4.8",
      "reviewsCount": 243,
      "price": "\u20b95,250",
      "oldPrice": "\u20b96,562",
      "discount": "20% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras"
      ],
      "sku": "DS-2CD1043G0-IUF",
      "description": "HIKVISION IP 4MP Bullet H.265+ Network CCTV | DS-2CD1043G0-IUF. High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_279",
      "name": "HIKVISION IP 4MP Dome Smart Hybrid Light with MIC CCTV (DS-2CD1341G2-LIU)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_28fa0630028f45558711bfd56130c01c_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 118,
      "price": "\u20b95,450",
      "oldPrice": "\u20b96,812",
      "discount": "20% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras"
      ],
      "sku": "DS-2CD1341G2-LIU",
      "description": "HIKVISION IP 4MP Dome Smart Hybrid Light with MIC CCTV (DS-2CD1341G2-LIU). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_280",
      "name": "HIKVISION IP 4MP Bullet Smart Hybrid Light with MIC CCTV (DS-2CD1041G2-LIU)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_f112b48de710490691b917493c9082af_mv2.jpg",
      "rating": "4.0",
      "reviewsCount": 205,
      "price": "\u20b96,450",
      "oldPrice": "\u20b98,486",
      "discount": "24% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras"
      ],
      "sku": "DS-2CD1041G2-LIU",
      "description": "HIKVISION IP 4MP Bullet Smart Hybrid Light with MIC CCTV (DS-2CD1041G2-LIU). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_281",
      "name": "HIKVISION IP 6MP Dome Smart Hybrid CCTV with MIC (DS-2CD1363G2-LIU)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_28fa0630028f45558711bfd56130c01c_mv2.jpg",
      "rating": "4.8",
      "reviewsCount": 162,
      "price": "\u20b96,950",
      "oldPrice": "\u20b98,910",
      "discount": "22% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras"
      ],
      "sku": "DS-2CD1363G2-LIU",
      "description": "HIKVISION IP 6MP Dome Smart Hybrid CCTV with MIC (DS-2CD1363G2-LIU). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_282",
      "name": "HIKVISION IP 6MP Bullet Smart Hybrid CCTV with MIC (DS-2CD1063G2-LIU)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_f112b48de710490691b917493c9082af_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 230,
      "price": "\u20b96,450",
      "oldPrice": "\u20b97,865",
      "discount": "18% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras"
      ],
      "sku": "DS-2CD1063G2-LIU",
      "description": "HIKVISION IP 6MP Bullet Smart Hybrid CCTV with MIC (DS-2CD1063G2-LIU). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_283",
      "name": "HIKVISION IP 8MP WDR Dome Network CCTV (DS-2CD1383G0-I)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_bbd83ebb2347449dbdae96088aae6744_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 270,
      "price": "\u20b98,450",
      "oldPrice": "\u20b910,974",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras",
            "4K"
      ],
      "sku": "DS-2CD1383G0-I",
      "description": "HIKVISION IP 8MP WDR Dome Network CCTV (DS-2CD1383G0-I). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_284",
      "name": "HIKVISION Pro IP 6MP Varifocal (2.7mm-13.5mm) Bullet CCTV (DS-2CD3663G1-IZS)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_4d7b14d13d4e4fff999d4e22746bc34c_mv2.jpg",
      "rating": "4.7",
      "reviewsCount": 151,
      "price": "\u20b911,950",
      "oldPrice": "\u20b915,126",
      "discount": "21% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": true,
      "tags": [
            "Hikvision",
            "IP Cameras"
      ],
      "sku": "DS-2CD3663G1-IZS",
      "description": "HIKVISION Pro IP 6MP Varifocal (2.7mm-13.5mm) Bullet CCTV (DS-2CD3663G1-IZS). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_285",
      "name": "HIKVISION IP 2MP 2.0MP IP 25x 100mtrs Speed Dome PTZ (DS-2DE4225IW-DE)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_dcad9fb0b39c462a822041b5f2cdb309_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 203,
      "price": "\u20b936,500",
      "oldPrice": "\u20b946,794",
      "discount": "22% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras",
            "2MP"
      ],
      "sku": "DS-2DE4225IW-DE",
      "description": "HIKVISION IP 2MP 2.0MP IP 25x 100mtrs Speed Dome PTZ (DS-2DE4225IW-DE). High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_286",
      "name": "HIKVISION Pro IP 4mp 32X 200m DarkFighter IR PTZ Network Speed Dome Camera",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_6e78555113f64298b1208694d15a69af_mv2.jpg",
      "rating": "4.9",
      "reviewsCount": 177,
      "price": "\u20b962,500",
      "oldPrice": "\u20b981,168",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "IP Cameras"
      ],
      "sku": "DS-2DE7A432IW-AEB",
      "description": "HIKVISION Pro IP 4mp 32X 200m DarkFighter IR PTZ Network Speed Dome Camera. High quality Hikvision IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_287",
      "name": "HIKVISION 4 Channel H.265+ NVR (DS-7104NI-Q1/M)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_9b083c809609450c90a2e4271b4f40d2_mv2.jpg",
      "rating": "4.4",
      "reviewsCount": 204,
      "price": "\u20b95,250",
      "oldPrice": "\u20b96,481",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 15,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "CCTV Accessories"
      ],
      "sku": "DS-7104NI-Q1/M",
      "description": "HIKVISION 4 Channel H.265+ NVR (DS-7104NI-Q1/M). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_288",
      "name": "HIKVISION 8 Channel H.265+ NVR (DS-7108NI-Q1/M)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_9b083c809609450c90a2e4271b4f40d2_mv2.jpg",
      "rating": "4.2",
      "reviewsCount": 170,
      "price": "\u20b96,350",
      "oldPrice": "\u20b97,839",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 16,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "CCTV Accessories"
      ],
      "sku": "DS-7108NI-Q1/M",
      "description": "HIKVISION 8 Channel H.265+ NVR (DS-7108NI-Q1/M). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_289",
      "name": "HIKVISION 16 Channel H.265+ Embedded NVR (DS-7616NI-Q1)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_9b083c809609450c90a2e4271b4f40d2_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 195,
      "price": "\u20b99,500",
      "oldPrice": "\u20b912,837",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 67,
      "isDeal": true,
      "tags": [
            "Hikvision",
            "CCTV Accessories"
      ],
      "sku": "DS-7616NI-Q1",
      "description": "HIKVISION 16 Channel H.265+ Embedded NVR (DS-7616NI-Q1). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_290",
      "name": "HIKVISION 8 Channel 4K AcuSense H.265+NVR (DS-7608NXI-K1)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_9b083c809609450c90a2e4271b4f40d2_mv2.jpg",
      "rating": "4.8",
      "reviewsCount": 132,
      "price": "\u20b99,750",
      "oldPrice": "\u20b911,890",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 44,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "DS-7608NXI-K1",
      "description": "HIKVISION 8 Channel 4K AcuSense H.265+NVR (DS-7608NXI-K1). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_291",
      "name": "HIKVISION 16 Channel 4K AcuSense H.265+ NVR (DS-7616NXI-K1)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_9b083c809609450c90a2e4271b4f40d2_mv2.jpg",
      "rating": "4.0",
      "reviewsCount": 135,
      "price": "\u20b912,500",
      "oldPrice": "\u20b916,447",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 58,
      "isDeal": true,
      "tags": [
            "Hikvision",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "DS-7616NXI-K1",
      "description": "HIKVISION 16 Channel 4K AcuSense H.265+ NVR (DS-7616NXI-K1). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_292",
      "name": "HIKVISION Pro 16 Channel 4K 2SATA AcuSense H.265+ NVR (DS-7616NXI-K2)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_60f01f811679470abcc085f02e2c50d7_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 204,
      "price": "\u20b914,950",
      "oldPrice": "\u20b919,415",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "DS-7616NXI-K2",
      "description": "HIKVISION Pro 16 Channel 4K 2SATA AcuSense H.265+ NVR (DS-7616NXI-K2). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_293",
      "name": "HIKVISION Pro 32 Channel 4K 2SATA H.265+ Embedded NVR (DS-7632NXI-K2)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_60f01f811679470abcc085f02e2c50d7_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 188,
      "price": "\u20b919,500",
      "oldPrice": "\u20b925,000",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 76,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "DS-7632NXI-K2",
      "description": "HIKVISION Pro 32 Channel 4K 2SATA H.265+ Embedded NVR (DS-7632NXI-K2). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_294",
      "name": "HIKVISION Pro 32 Channel 4K 4-SATA AcuSense H.265+ NVR (DS-7732NXI-K4)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_801755fdf4ce44a6a72b4966f5d55529_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 186,
      "price": "\u20b934,500",
      "oldPrice": "\u20b943,125",
      "discount": "20% OFF",
      "inStock": true,
      "stockQuantity": 82,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "DS-7732NXI-K4",
      "description": "HIKVISION Pro 32 Channel 4K 4-SATA AcuSense H.265+ NVR (DS-7732NXI-K4). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_295",
      "name": "HIKVISION Pro 64 Channel 8K 4-SATA H.265+ Embedded NVR (DS-7764NI-M4)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_801755fdf4ce44a6a72b4966f5d55529_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 229,
      "price": "\u20b959,500",
      "oldPrice": "\u20b976,282",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 34,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "CCTV Accessories"
      ],
      "sku": "DS-7764NI-M4",
      "description": "HIKVISION Pro 64 Channel 8K 4-SATA H.265+ Embedded NVR (DS-7764NI-M4). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_296",
      "name": "HIKVISION Pro 64 Channel 4K 8-SATA H.265+ Embedded NVR (DS-8664NXI-I8/S)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_63d94c6fd873476cb6a9a1d9310600f0_mv2.jpg",
      "rating": "4.8",
      "reviewsCount": 190,
      "price": "\u20b984,500",
      "oldPrice": "\u20b9106,962",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 48,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "DS-8664NXI-I8/S",
      "description": "HIKVISION Pro 64 Channel 4K 8-SATA H.265+ Embedded NVR (DS-8664NXI-I8/S). High quality Hikvision CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_297",
      "name": "HIKVISION 4 Port PoE Switch (DS-3E0105P-E/M)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_c6f7e87a3c5a4216bbcf272396f46bcd_mv2.jpg",
      "rating": "4.5",
      "reviewsCount": 199,
      "price": "\u20b92,250",
      "oldPrice": "\u20b93,000",
      "discount": "25% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "Network Switches",
            "PoE"
      ],
      "sku": "DS-3E0105P-E/M",
      "description": "HIKVISION 4 Port PoE Switch (DS-3E0105P-E/M). High quality Hikvision Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_298",
      "name": "HIKVISION 8 Port PoE Switch (DS-3E0109P-E/M)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_a9b13539e5fe476585c9826d450223ea_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 277,
      "price": "\u20b93,750",
      "oldPrice": "\u20b94,687",
      "discount": "20% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "Network Switches",
            "PoE"
      ],
      "sku": "DS-3E0109P-E/M",
      "description": "HIKVISION 8 Port PoE Switch (DS-3E0109P-E/M). High quality Hikvision Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_299",
      "name": "HIKVISION 16 Port PoE Switch (DS-3E0318P-E/M)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_8472e83a7a084e608f7a79675763a6ca_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 206,
      "price": "\u20b911,750",
      "oldPrice": "\u20b914,506",
      "discount": "19% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "Network Switches",
            "PoE"
      ],
      "sku": "DS-3E0318P-E/M",
      "description": "HIKVISION 16 Port PoE Switch (DS-3E0318P-E/M). High quality Hikvision Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_300",
      "name": "HIKVISION 24 Port PoE Switch (DS-3E0326P-E/M)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_65598291707b425ba85ab210950b3f8c_mv2.jpg",
      "rating": "4.7",
      "reviewsCount": 193,
      "price": "\u20b914,950",
      "oldPrice": "\u20b918,924",
      "discount": "21% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "Network Switches",
            "PoE"
      ],
      "sku": "DS-3E0326P-E/M",
      "description": "HIKVISION 24 Port PoE Switch (DS-3E0326P-E/M). High quality Hikvision Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_301",
      "name": "HIKVISION 8 Port Giga PoE Switch (DS-3E0510P-E/M)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_2b23a091567f4e608b125afde9e43eb5_mv2.jpg",
      "rating": "4.1",
      "reviewsCount": 58,
      "price": "\u20b95,950",
      "oldPrice": "\u20b97,531",
      "discount": "21% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "Network Switches",
            "PoE"
      ],
      "sku": "DS-3E0510P-E/M",
      "description": "HIKVISION 8 Port Giga PoE Switch (DS-3E0510P-E/M). High quality Hikvision Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_302",
      "name": "HIKVISION 16 Port Giga Managed PoE Switch (DS-3E1518P-EI/M)",
      "category": "IT & Networking",
      "subcategory": "Network Switches",
      "brand": "Hikvision",
      "image": "/assets/images/nicedeal/fa1b6a_8472e83a7a084e608f7a79675763a6ca_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 72,
      "price": "\u20b912,450",
      "oldPrice": "\u20b916,600",
      "discount": "25% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Hikvision",
            "Network Switches",
            "PoE"
      ],
      "sku": "DS-3E1518P-EI/M",
      "description": "HIKVISION 16 Port Giga Managed PoE Switch (DS-3E1518P-EI/M). High quality Hikvision Network Switches designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_303",
      "name": "CP Plus CAT6 UTP Copper Cable (Loose)",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "CP Plus",
      "image": "/assets/images/nicedeal/fa1b6a_acddb1bdbe5548a8bcf6cbc629d45710_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 134,
      "price": "\u20b939",
      "oldPrice": "\u20b952",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 61,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "Cables & Connectors"
      ],
      "sku": "",
      "description": "CP Plus CAT6 UTP Copper Cable (Loose). High quality CP Plus Cables & Connectors designed for professional IT & Networking setups. Reliability and performance guaranteed."
},
{
      "id": "prod_304",
      "name": "eSSL F22 Biometric Fingerprint & RFID Time Attendance and Access Control Termina",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "eSSL",
      "image": "/assets/images/biometric.png",
      "rating": "4.1",
      "reviewsCount": 37,
      "price": "\u20b98,750",
      "oldPrice": "\u20b911,513",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 25,
      "isDeal": false,
      "tags": [
            "eSSL",
            "Biometric Systems"
      ],
      "sku": "REALTIME-T304F-MINI-FACE-ATTENDANCE-SYSTEM-WITH-ACCESS-CONTROL",
      "description": "eSSL F22 Biometric Fingerprint & RFID Time Attendance and Access Control Termina. Professional grade eSSL Biometric Systems designed for secure enterprise deployments."
},
{
      "id": "prod_305",
      "name": "eSSL K90 Pro Identix Fingerprint Time & Attendance with Access Control",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "eSSL",
      "image": "/assets/images/biometric.png",
      "rating": "4.7",
      "reviewsCount": 272,
      "price": "\u20b98,750",
      "oldPrice": "\u20b911,824",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 18,
      "isDeal": false,
      "tags": [
            "eSSL",
            "Biometric Systems"
      ],
      "sku": "ESSL-F22-WI-FI-FINGERPRINT-BIOMETRIC-TIME-ATTENDANCE-MACHINE",
      "description": "eSSL K90 Pro Identix Fingerprint Time & Attendance with Access Control. Professional grade eSSL Biometric Systems designed for secure enterprise deployments."
},
{
      "id": "prod_306",
      "name": "Realtime T501 Mini Face with Finger Attendance and Access Control System",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.8",
      "reviewsCount": 268,
      "price": "\u20b911,450",
      "oldPrice": "\u20b915,266",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 29,
      "isDeal": false,
      "tags": [
            "Realtime",
            "Biometric Systems"
      ],
      "sku": "REALTIME-T501-MINI-FACE-WITH-FINGER-ATTENDANCE-AND-ACCESS-CONTROL-SYSTEM",
      "description": "Realtime T502-L1 Aadhaar-enabled biometric attendance system. Professional grade Realtime Biometric Systems designed for secure enterprise deployments."
},
{
      "id": "prod_307",
      "name": "Realtime T503F-L1 Aadhaar-enabled Face Attendance System",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.9",
      "reviewsCount": 197,
      "price": "\u20b921,500",
      "oldPrice": "\u20b929,054",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 68,
      "isDeal": false,
      "tags": [
            "Realtime",
            "Biometric Systems"
      ],
      "sku": "REALTIME-T502-L1-AADHAAR-ENABLED-BIOMETRIC-ATTENDANCE-SYSTEM",
      "description": "Realtime T503F-L1 Aadhaar-enabled Face Attendance System. Professional grade Realtime Biometric Systems designed for secure enterprise deployments."
},
{
      "id": "prod_308",
      "name": "Realtime RS70 Biometric Attendance Machine with Access Control",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.8",
      "reviewsCount": 263,
      "price": "\u20b941,500",
      "oldPrice": "\u20b955,333",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 32,
      "isDeal": false,
      "tags": [
            "Realtime",
            "Biometric Systems"
      ],
      "sku": "REALTIME-T503F-L1-AADHAAR-ENABLED-FACE-ATTENDANCE-SYSTEM",
      "description": "Realtime RS70 Biometric Attendance Machine with Access Control. Professional grade Realtime Biometric Systems designed for secure enterprise deployments."
},
{
      "id": "prod_309",
      "name": "Realtime Pro 1100n Face Attendance System",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.7",
      "reviewsCount": 176,
      "price": "\u20b97,450",
      "oldPrice": "\u20b99,933",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 78,
      "isDeal": false,
      "tags": [
            "Realtime",
            "Biometric Systems"
      ],
      "sku": "REALTIME-RS70-BIOMETRIC-ATTENDANCE-MACHINE-WITH-ACCESS-CONTROL",
      "description": "Realtime Pro 1100n Face Attendance System. Professional grade Realtime Biometric Systems designed for secure enterprise deployments."
},
{
      "id": "prod_310",
      "name": "Realtime Pro 1100b Face & Biometric Attendance System",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.2",
      "reviewsCount": 74,
      "price": "\u20b912,350",
      "oldPrice": "\u20b915,632",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 48,
      "isDeal": false,
      "tags": [
            "Realtime",
            "Biometric Systems"
      ],
      "sku": "REALTIME-PRO-1100N-FACE-ATTENDANCE-SYSTEM",
      "description": "Realtime Pro 1100b Face & Biometric Attendance System. Professional grade Realtime Biometric Systems designed for secure enterprise deployments."
},
{
      "id": "prod_311",
      "name": "Realtime Pro 1400f Face & Biometric Attendance System",
      "category": "Security Systems",
      "subcategory": "Biometric Systems",
      "brand": "Realtime",
      "image": "/assets/images/biometric.png",
      "rating": "4.3",
      "reviewsCount": 76,
      "price": "\u20b915,150",
      "oldPrice": "\u20b918,937",
      "discount": "20% OFF",
      "inStock": true,
      "stockQuantity": 29,
      "isDeal": false,
      "tags": [
            "Realtime",
            "Biometric Systems"
      ],
      "sku": "REALTIME-PRO-1100B-FACE-BIOMETRIC-ATTENDANCE-SYSTEM",
      "description": "Realtime Pro 1400f Face & Biometric Attendance System. Professional grade Realtime Biometric Systems designed for secure enterprise deployments."
},
{
      "id": "prod_312",
      "name": "Dahua IP 4MP Hybrid Bullet CCTV with MIC (IPC-HFW1439TL2-A-IL)",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "Dahua",
      "image": "/assets/images/nicedeal/fa1b6a_1a7e0a7c91fb40dbbc4f0f277e8b337b_mv2.jpg",
      "rating": "4.6",
      "reviewsCount": 144,
      "price": "\u20b93,400",
      "oldPrice": "\u20b94,197",
      "discount": "19% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "Dahua",
            "IP Cameras"
      ],
      "sku": "DH-IPC-HFW1439TL2-A-IL",
      "description": "Dahua IP 4MP Hybrid Bullet CCTV with MIC (IPC-HFW1439TL2-A-IL). High quality Dahua IP Cameras designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_313",
      "name": "Dahua Pro 16 Channel 2 SATA H.265+ Embedded NVR (DHI-NVR4216-4KS2/L)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "Dahua",
      "image": "/assets/images/nicedeal/fa1b6a_d0a6889372c54f1dbd28510b226e7894_mv2.jpg",
      "rating": "4.3",
      "reviewsCount": 273,
      "price": "\u20b911,000",
      "oldPrice": "\u20b913,414",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 65,
      "isDeal": false,
      "tags": [
            "Dahua",
            "CCTV Accessories",
            "4K"
      ],
      "sku": "NVR4216-4KS2/L",
      "description": "Dahua Pro 16 Channel 2 SATA H.265+ Embedded NVR (DHI-NVR4216-4KS2/L). High quality Dahua CCTV Accessories designed for professional Security Systems setups. Reliability and performance guaranteed."
},
{
      "id": "prod_314",
      "name": "CP Plus 2MP Network IP Bullet Camera (30m, PoE) | CP-UNC-TA21L3C-Q",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.4",
      "reviewsCount": 45,
      "price": "\u20b92,850",
      "oldPrice": "\u20b93,750",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 85,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "CP-PLUS-2MP-NETWORK-IP-DOME-CAMERA-STQC-30M-POE-IP67-CP-UNC-DA21L3C-Q",
      "description": "CP Plus 2MP Network IP Bullet Camera (30m, PoE) | CP-UNC-TA21L3C-Q. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_315",
      "name": "CP Plus 2MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA21L3C-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.8",
      "reviewsCount": 187,
      "price": "\u20b92,900",
      "oldPrice": "\u20b93,815",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 61,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-2MP-NETWORK-IP-BULLET-CAMERA-30M-POE-CP-UNC-TA21L3C-Q",
      "description": "CP Plus 2MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA21L3C-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_316",
      "name": "CP Plus 2MP Night Color IP Bullet Camera (30m, PoE) | CP-UNC-TA21L3C-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.7",
      "reviewsCount": 147,
      "price": "\u20b93,100",
      "oldPrice": "\u20b93,924",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 74,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-2MP-FULL-COLOR-IP-DOME-CAMERA-30M-POE-IP67-CP-UNC-DA21L3C-L",
      "description": "CP Plus 2MP Night Color IP Bullet Camera (30m, PoE) | CP-UNC-TA21L3C-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_317",
      "name": "CP Plus 2MP Night Color IP Dome CCTV | Two Way | CP-UNC-DA21L3B-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.4",
      "reviewsCount": 234,
      "price": "\u20b93,150",
      "oldPrice": "\u20b94,144",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 55,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-2MP-NIGHT-COLOR-IP-BULLET-CAMERA-30M-POE-CP-UNC-TA21L3C-LQ",
      "description": "CP Plus 2MP Night Color IP Dome CCTV | Two Way | CP-UNC-DA21L3B-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_318",
      "name": "CP Plus 2MP Night Color IP Bullet CCTV | Two Way | CP-UNC-TA21L3B-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.8",
      "reviewsCount": 100,
      "price": "\u20b93,250",
      "oldPrice": "\u20b93,963",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 80,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-2MP-NIGHT-COLOR-IP-DOME-CCTV-TWO-WAY-CP-UNC-DA21L3B-LQ",
      "description": "CP Plus 2MP Night Color IP Bullet CCTV | Two Way | CP-UNC-TA21L3B-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_319",
      "name": "CP Plus 4MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA41L3C-D-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.5",
      "reviewsCount": 48,
      "price": "\u20b93,300",
      "oldPrice": "\u20b94,342",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 22,
      "isDeal": true,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-2MP-NIGHT-COLOR-IP-BULLET-CCTV-TWO-WAY-CP-UNC-TA21L3B-LQ",
      "description": "CP Plus 4MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA41L3C-D-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_320",
      "name": "CP Plus 4MP Night Color IP Bullet Camera (30m, PoE) | CP-UNC-TA41L3C-D-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.4",
      "reviewsCount": 60,
      "price": "\u20b93,850",
      "oldPrice": "\u20b95,065",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 45,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-4MP-FULL-COLOR-IP-DOME-CAMERA-30M-POE-CP-UNC-DA41L3C-D-LQ",
      "description": "CP Plus 4MP Night Color IP Bullet Camera (30m, PoE) | CP-UNC-TA41L3C-D-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_321",
      "name": "CP Plus 6MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA61L3C-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.4",
      "reviewsCount": 207,
      "price": "\u20b93,900",
      "oldPrice": "\u20b95,000",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 60,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-4MP-NIGHT-COLOR-IP-BULLET-CAMERA-30M-POE-CP-UNC-TA41L3C-D-LQ",
      "description": "CP Plus 6MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA61L3C-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_322",
      "name": "CP Plus 6MP Night Color IP Bullet Camera (30m, PoE) | CP-UNC-TA61L3C-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.7",
      "reviewsCount": 164,
      "price": "\u20b95,300",
      "oldPrice": "\u20b96,543",
      "discount": "19% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-6MP-FULL-COLOR-IP-DOME-CAMERA-30M-POE-CP-UNC-DA61L3C-D-LQ",
      "description": "CP Plus 6MP Night Color IP Bullet Camera (30m, PoE) | CP-UNC-TA61L3C-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_323",
      "name": "CP Plus 8MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA81L3C-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.7",
      "reviewsCount": 61,
      "price": "\u20b95,350",
      "oldPrice": "\u20b96,948",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "CP-UNC-TS21PL3-CP-PLUS-IP-2MP-BULLET-NETWORK-OUTDOOR-CCTV-CAMERA",
      "description": "CP Plus 8MP Full Color IP Dome Camera (30m, PoE) | CP-UNC-DA81L3C-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_324",
      "name": "CP Plus 8MP Night Color IP Bullet Camera (30m, PoE) | CP-UNC-TA81L3C-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.1",
      "reviewsCount": 55,
      "price": "\u20b97,250",
      "oldPrice": "\u20b98,841",
      "discount": "18% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "CP-UNC-DS41PL3-CP-PLUS-IP-4MP-DOME-NETWORK-INDOOR-CCTV-CAMERA",
      "description": "CP Plus 8MP Night Color IP Bullet Camera (30m, PoE) | CP-UNC-TA81L3C-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_325",
      "name": "CP Plus 4 MP Dual-Light Vandal Dome Camera | CP-UNC-VC41L5C-VMD-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/dome-camera.png",
      "rating": "4.2",
      "reviewsCount": 45,
      "price": "\u20b97,300",
      "oldPrice": "\u20b99,240",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 31,
      "isDeal": true,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "CP-UNC-TS41PL3-CP-PLUS-IP-4MP-BULLET-NETWORK-OUTDOOR-CCTV-CAMERA",
      "description": "CP Plus 4 MP Dual-Light Vandal Dome Camera | CP-UNC-VC41L5C-VMD-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_326",
      "name": "CP Plus IP 4MP 50m Bullet CCTV | CP-UNC-TC41L5C-VMD-LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.6",
      "reviewsCount": 146,
      "price": "\u20b97,350",
      "oldPrice": "\u20b99,423",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 71,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-4-MP-DUAL-LIGHT-VANDAL-DOME-CAMERA-CP-UNC-VC41L5C-VMD-LQ",
      "description": "CP Plus IP 4MP 50m Bullet CCTV | CP-UNC-TC41L5C-VMD-LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_327",
      "name": "CP Plus IP 4MP VariFocal 60m Bullet CCTV | CP\u2011UNC\u2011TC41ZL6C\u2011VMD\u2011LQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/bullet-camera.png",
      "rating": "4.2",
      "reviewsCount": 93,
      "price": "\u20b97,350",
      "oldPrice": "\u20b99,187",
      "discount": "20% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "STQC-CP-PLUS-IP-4MP-50M-BULLET-CCTV-CP-UNC-TC41L5C-VMD-LQ",
      "description": "CP Plus IP 4MP VariFocal 60m Bullet CCTV | CP\u2011UNC\u2011TC41ZL6C\u2011VMD\u2011LQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_328",
      "name": "CP Plus Pro IP 4mp ANPR AI Enforcement CCTV Camera | CP-UNC-TT41L3-VMD-Q",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/ip-camera.png",
      "rating": "4.1",
      "reviewsCount": 48,
      "price": "\u20b911,000",
      "oldPrice": "\u20b914,102",
      "discount": "22% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "CP-PLUS-IP-4MP-WDR-VARIFOCAL-BULLET-CCTV-CP-UNC-TB41ZL6-VMDS",
      "description": "CP Plus Pro IP 4mp ANPR AI Enforcement CCTV Camera | CP-UNC-TT41L3-VMD-Q. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_329",
      "name": "CP Plus IP 2MP 25x 100mtrs Network PTZ Camera | CP-UNP-D2521L10-DAQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/ip-camera.png",
      "rating": "4.8",
      "reviewsCount": 227,
      "price": "\u20b962,500",
      "oldPrice": "\u20b982,236",
      "discount": "24% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "CP-PLUS-PRO-IP-4MP-ANPR-AI-ENFORCEMENT-CAMERACAMERA-CP-UNC-TT41L3-VM",
      "description": "CP Plus IP 2MP 25x 100mtrs Network PTZ Camera | CP-UNP-D2521L10-DAQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_330",
      "name": "CP Plus IP 4MP 32x 175mtrs Network PTZ Camera | CP-UNP-E3241L18-DAQ",
      "category": "Security Systems",
      "subcategory": "IP Cameras",
      "brand": "CP Plus",
      "image": "/assets/images/ip-camera.png",
      "rating": "4.2",
      "reviewsCount": 159,
      "price": "\u20b934,750",
      "oldPrice": "\u20b944,551",
      "discount": "22% OFF",
      "inStock": true,
      "stockQuantity": 25,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "IP Cameras"
      ],
      "sku": "CP-UNP-D2521L10-DP-CP-PLUS-IP-2MP-25X-100MTRS-NETWORK-PTZ-CCTV-CAMERA",
      "description": "CP Plus IP 4MP 32x 175mtrs Network PTZ Camera | CP-UNP-E3241L18-DAQ. Professional grade CP Plus IP Cameras designed for secure enterprise deployments."
},
{
      "id": "prod_331",
      "name": "CP Plus 4K 16 Channel H.265+ NVR | CP-UNR-4K2161-V4",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.5",
      "reviewsCount": 96,
      "price": "\u20b95,450",
      "oldPrice": "\u20b96,646",
      "discount": "18% OFF",
      "inStock": true,
      "stockQuantity": 84,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "CCTV Accessories"
      ],
      "sku": "CP-UNR-C1081-H-CP-PLUS-8-CHANNEL-EMBEDDED-NVR",
      "description": "CP Plus 4K 16 Channel H.265+ NVR | CP-UNR-4K2161-V4. Professional grade CP Plus CCTV Accessories designed for secure enterprise deployments."
},
{
      "id": "prod_332",
      "name": "CP Plus Pro 16 Channel 4K 2 SATA H.265+NVR (CP-UNR-4K4162-V4)",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.4",
      "reviewsCount": 224,
      "price": "\u20b98,350",
      "oldPrice": "\u20b911,283",
      "discount": "26% OFF",
      "inStock": true,
      "stockQuantity": 20,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "CCTV Accessories"
      ],
      "sku": "CP-PLUS-16-CHANNEL-H-265-EMBEDDED-NVR-CP-UNR-216F1-V3",
      "description": "CP Plus Pro 16 Channel 4K 2 SATA H.265+NVR (CP-UNR-4K4162-V4). Professional grade CP Plus CCTV Accessories designed for secure enterprise deployments."
},
{
      "id": "prod_333",
      "name": "CP Plus Pro 32 Channel 4K 2SATA H.265+ Embedded NVR | CP-UNR-4K4322-V4",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.0",
      "reviewsCount": 250,
      "price": "\u20b911,500",
      "oldPrice": "\u20b914,197",
      "discount": "19% OFF",
      "inStock": true,
      "stockQuantity": 74,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "CCTV Accessories"
      ],
      "sku": "CP-UNR-4K4162-V2-CP-PLUS-16-CHANNEL-2-SATA-H-265-EMBEDDED-NVR",
      "description": "CP Plus Pro 32 Channel 4K 2SATA H.265+ Embedded NVR | CP-UNR-4K4322-V4. Professional grade CP Plus CCTV Accessories designed for secure enterprise deployments."
},
{
      "id": "prod_334",
      "name": "CP Plus Pro 64 Channel 4K 4SATA H.265+ Embedded NVR | CP-UNR-4K5644-FI",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.3",
      "reviewsCount": 270,
      "price": "\u20b916,500",
      "oldPrice": "\u20b921,710",
      "discount": "24% OFF",
      "inStock": true,
      "stockQuantity": 31,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "CCTV Accessories"
      ],
      "sku": "CP-UNR-4K4322-V2-CP-PLUS-32-CHANNEL-2-SATA-H-265-EMBEDDED-NVR",
      "description": "CP Plus Pro 64 Channel 4K 4SATA H.265+ Embedded NVR | CP-UNR-4K5644-FI. Professional grade CP Plus CCTV Accessories designed for secure enterprise deployments."
},
{
      "id": "prod_335",
      "name": "CP Plus CP-UNR-4K564R8-FI 64-Channel AI 8 SATA ANPR NVR",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.5",
      "reviewsCount": 173,
      "price": "\u20b939,500",
      "oldPrice": "\u20b952,666",
      "discount": "25% OFF",
      "inStock": true,
      "stockQuantity": 80,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "CCTV Accessories"
      ],
      "sku": "CP-PLUS-PRO-64-CHANNEL-4K-4SATA-H-265-EMBEDDED-NVR-CP-UNR-4K5644-V2",
      "description": "CP Plus CP-UNR-4K564R8-FI 64-Channel AI 8 SATA ANPR NVR. Professional grade CP Plus CCTV Accessories designed for secure enterprise deployments."
},
{
      "id": "prod_336",
      "name": "CP Plus 128 Channel AI 8 SATA ANPR 4K NVR | CP-UNR-4K5128R8-EI",
      "category": "Security Systems",
      "subcategory": "CCTV Accessories",
      "brand": "CP Plus",
      "image": "/assets/images/nvr.png",
      "rating": "4.7",
      "reviewsCount": 172,
      "price": "\u20b959,500",
      "oldPrice": "\u20b975,316",
      "discount": "21% OFF",
      "inStock": true,
      "stockQuantity": 53,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "CCTV Accessories"
      ],
      "sku": "CP-PLUS-CP-UNR-4K564R8-FI-64-CHANNEL-AI-8-SATA-ANPR-NVR",
      "description": "CP Plus 128 Channel AI 8 SATA ANPR 4K NVR | CP-UNR-4K5128R8-EI. Professional grade CP Plus CCTV Accessories designed for secure enterprise deployments."
},
{
      "id": "prod_337",
      "name": "CP Plus CAT6 305mtrs UTP Copper Cable (CP-EUT-6TGL23-305)",
      "category": "IT & Networking",
      "subcategory": "Cables & Connectors",
      "brand": "CP Plus",
      "image": "/assets/images/cat6-cable.png",
      "rating": "4.1",
      "reviewsCount": 265,
      "price": "\u20b93,750",
      "oldPrice": "\u20b94,746",
      "discount": "21% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "Cables & Connectors"
      ],
      "sku": "CP-PLUS-CAT6-100MTRS-UTP-COPPER-CABLE-CP-EUT-6TGL23-100",
      "description": "CP Plus CAT6 305mtrs UTP Copper Cable (CP-EUT-6TGL23-305). Professional grade CP Plus Cables & Connectors designed for secure enterprise deployments."
},
{
      "id": "prod_338",
      "name": "CP Plus 4G SIM Card Wi-Fi Router (CP-XR-DE21-S)",
      "category": "IT & Networking",
      "subcategory": "WiFi Routers & Access Points",
      "brand": "CP Plus",
      "image": "/assets/images/router.png",
      "rating": "4.5",
      "reviewsCount": 229,
      "price": "\u20b92,150",
      "oldPrice": "\u20b92,800",
      "discount": "23% OFF",
      "inStock": false,
      "stockQuantity": 0,
      "isDeal": false,
      "tags": [
            "CP Plus",
            "WiFi Routers & Access Points",
            "Router",
            "4G"
      ],
      "sku": "CP-XR-DE21-S",
      "description": "CP Plus 4G SIM Card Wi-Fi Router for wireless IP camera connectivity, supporting dual-band Wi-Fi, 4G LTE SIM, multiple device connectivity, and easy remote access."
}
  ]
};

if (typeof window !== 'undefined') {
  try {
    const savedCustom = localStorage.getItem('products_db_custom');
    if (savedCustom) {
      const customProducts = JSON.parse(savedCustom);
      const existingIds = new Set(dbProducts.products.map((p: any) => p.id));
      const uniqueCustom = customProducts.filter((p: any) => !existingIds.has(p.id));
      dbProducts.products.unshift(...uniqueCustom);
    }
    
    const savedStaticEdited = localStorage.getItem('products_db_static_edited');
    if (savedStaticEdited) {
      const staticEdited = JSON.parse(savedStaticEdited);
      staticEdited.forEach((editedProd: any) => {
        const idx = dbProducts.products.findIndex((p: any) => p.id === editedProd.id);
        if (idx !== -1) {
          dbProducts.products[idx] = editedProd;
        }
      });
    }

    const deletedIds = JSON.parse(localStorage.getItem('products_db_deleted_ids') || '[]');
    if (deletedIds.length > 0) {
      const deletedSet = new Set(deletedIds);
      dbProducts.products = dbProducts.products.filter((p: any) => !deletedSet.has(p.id));
    }
  } catch (e) {
    console.error("Failed to seed custom/edited products", e);
  }
}